/* ═══════════════════════════════════════════════════════════
   NATULIM QUIZ v3.0 — JS (CaaS + Shipment Boxes)
   Shopify Theme Asset — Phase 1: Visual
   Wrapped in IIFE for scope isolation
   ═══════════════════════════════════════════════════════════ */
(function() {
'use strict';

// Guard: prevent double initialization if both block + section load this script
if (window._ntlQuiz) return;

// ── PRODUCT DATABASE (verified from Shopify 2026-03-04) ──
const PRODUCTS = {
  det40: {
    name:'Detergente 40 lavados', handle:'tiras-de-detergente-para-lavadora-ecologicas-fragancia-natural',
    id:'6105943638181', price:11.95, discount:18, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET_-_PRODUCTOFOTO_40_-_FLORAL_-_ESP-ok-convertido-de-png_1_37e58e4e-cc18-4964-99e1-e8299dbf8d6f.webp?v=1764631494&width=150',
    frequencies:['30d','60d','90d'],
    lavBote:20, gPerLav:null,
    hasFragrance:true,
    variants: {
      'Floral':    '42672701145302',
      'Sin Fragancia': '37744675717285',
      'Lavanda':   '37744675750053'
    },
    variantImages: {
      'Floral':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET_-_PRODUCTOFOTO_40_-_FLORAL_-_ESP-ok-convertido-de-png_1_37e58e4e-cc18-4964-99e1-e8299dbf8d6f.webp?v=1764631494&width=150',
      'Sin Fragancia':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET_-_PRODUCTOFOTO_40_-_SIN_FRAGANCIA_-_ESP-OK-convertido-de-png_3173d067-4650-4815-8c1e-8d94d8df86fe.webp?v=1764631446&width=150',
      'Lavanda':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET_-_PRODUCTOFOTO_40_-_LAVANDA_-_ESP-ok-convertido-de-png_1_93b6a47f-672b-4fa6-a755-bd59eb9d55c5.webp?v=1764631471&width=150'
    }
  },
  det360: {
    name:'Pack 360 lavados', handle:'pack-ahorro-detergente-360-lavados',
    id:'7822551875798', price:102.56, compareAt:107.55, discount:22, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET_-_PRODUCTOFOTO_360_-_FLORAL_-_ESP_ok-convertido-de-png.webp?v=1764632092&width=150',
    frequencies:['10m','12m','18m'],
    lavBote:180, gPerLav:null,
    hasFragrance:true,
    variants: {
      'Floral':    '43494948274390',
      'Lavanda':   '43494948307158',
      'Sin Fragancia': '43494948339926'
    },
    variantImages: {
      'Floral':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET_-_PRODUCTOFOTO_360_-_FLORAL_-_ESP_ok-convertido-de-png.webp?v=1764632092&width=150',
      'Lavanda':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET_-_PRODUCTOFOTO_360_-_LAVANDA_-_ESP_ok-convertido-de-png.webp?v=1764632030&width=150',
      'Sin Fragancia':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET_-_PRODUCTOFOTO_360_-_SIN_FRAGANCIA_-_ESP_ok-convertido-de-png.webp?v=1764632068&width=150'
    }
  },
  bebe360: {
    name:'Eco-Tiras Bebés 360 Lavados', handle:'pack-ahorro-natulim-especial-para-bebes-360-lavados',
    id:'10386355814739', price:102.56, discount:22, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET-PRODUCTOFOTO360-SINFRAGANCIA-ESP.webp?v=1749030767&width=150',
    frequencies:['10m','12m','18m'],
    lavBote:180, gPerLav:null,
    variants: { 'Default Title': '52841641935187' }
  },
  bebe40: {
    name:'Eco-Tiras Bebés 40 Lavados', handle:'eco-tiras-de-detergente-natulim-especial-para-bebes-40-lavados',
    id:'10386329141587', price:11.95, discount:18, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/DET-PRODUCTOFOTO360-SINFRAGANCIA-ESP.webp?v=1749030767&width=150',
    frequencies:['30d','60d','90d'],
    variants: { 'Default Title': '52841568338259' }
  },
  oxis: {
    name:'Oxi Clean', handle:'oxi-clean',
    id:'8598782083411', price:11.06, discount:10, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/OXIC_-_PRODUCTOFOTO1_-_ESP-ok-convertido-de-png.webp?v=1764631674&width=150',
    frequencies:['30d','60d','90d','120d'],
    lavBote:41.67, gPerLav:12,
    variants: { 'Default': '47314257969491' }
  },
  oxiwhite: {
    name:'Oxi White', handle:'oxi-white',
    id:'8598676799827', price:11.06, discount:10, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/OXIW_-_PRODUCTOFOTO1_-_ESP-OK-convertido-de-png.webp?v=1764631690&width=150',
    frequencies:['30d','60d','90d','120d'],
    lavBote:41.67, gPerLav:12,
    variants: { 'Default': '47313889460563' }
  },
  perlas: {
    name:'Perlas Perfumadas', handle:'perlas-perfumadas-natulim',
    id:'8874651484499', price:9.58, discount:17, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/PER_-_PRODUCTO_-_AURORA_FOREST_-_ESP-OK-convertido-de-png_13f086d7-f807-4ff9-87ed-17e43a225405.webp?v=1766394722&width=150',
    frequencies:['30d','60d','90d'],
    hasFragrance:true,
    variants: {
      'Bosque Aurora': '48096902480211',
      'Floral':        '48096902414675',
      'Lavanda':       '48096902447443'
    },
    variantImages: {
      'Bosque Aurora':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/PER_-_PRODUCTO_-_AURORA_FOREST_-_ESP-OK-convertido-de-png_13f086d7-f807-4ff9-87ed-17e43a225405.webp?v=1766394722&width=150',
      'Floral':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/PER_-_PRODUCTO_-_FLORAL_-_ESP-OK-convertido-de-png_aaa10f35-dbb9-47f3-91aa-bec59a7fea80.webp?v=1768301952&width=150',
      'Lavanda':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/PER_-_PRODUCTO_-_LAVANDA_-_ESP-OK-convertido-de-png_4711b986-6839-4674-807b-2ef6c63d5bf2.webp?v=1768301952&width=150'
    }
  },
  quitamanchas: {
    name:'Quitamanchas', handle:'quitamanchas',
    id:'7936368017622', price:12.50, discount:10, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/QuitamanchasPDPfondoneutro700x700_1.png?v=1763417667&width=150',
    frequencies:['4m','8m','12m'],
    variants: { 'Default': '43837436723414' }
  },
  pastillas: {
    name:'Pastillas Lavavajillas 60ud', handle:'lavavajillas',
    id:'8463115551059', price:20.17, discount:11, category:'Cocina',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/LAV_P_-_PRODUCTOFOTO_-_ESP-OK-convertido-de-png_1.webp?v=1764631713&width=150',
    frequencies:['60d','90d','120d'],
    variants: { 'Default': '46807964221779' }
  },
  lavmano: {
    name:'Lavavajillas a Mano', handle:'pack-lavavajillas-a-mano',
    id:'9523575718227', price:16.00, compareAt:19.40, discount:19, category:'Cocina',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/PACKLAVAMAN_-_PRODUCTOFOTO_productodelano_-_ESP_ok_aa8b7966-4318-4471-9ab4-ae483cbb5a0a.webp?v=1771520975&width=150',
    frequencies:['3m','6m','12m'],
    variants: { 'Default': '49543387644243' },
    recurringPrice: 8.58
  },
  friegasuelos: {
    name:'Friegasuelos', handle:'friega-suelos-en-eco-tiras',
    id:'7642485620950', price:9.00, discount:20, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/FRI_-_PRODUCTOFOTO_-_SUELO_-_JAZMIN_-_ESP-ok-convertido-de-png.webp?v=1763382370&width=150',
    frequencies:['30d','60d','90d','120d'],
    variants: { 'Default': '42791546257622' }
  },
  flisflis: {
    name:'Pack Esenciales Flis-Flis', handle:'pack-esenciales-del-hogar',
    id:'9579400364371', price:34.08, compareAt:50.00, discount:12, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/PACKFLISFLIS-PRODUCTOFOTO-ESP.webp?v=1764631565&width=150',
    frequencies:['3m','6m','12m'],
    variants: {
      '2 de cada': '49712089137491',
      '4 de cada': '49712089170259',
      '6 de cada': '49712089203027'
    },
    variantPrices: {
      '2 de cada': {price:34.08, compareAt:50.00, subPrice:29.99},
      '4 de cada': {price:53.32, compareAt:72.00, subPrice:47.99},
      '6 de cada': {price:77.00, compareAt:94.00, subPrice:66.99}
    },
    recurringPrices: {
      '2 de cada': 18.96,
      '4 de cada': 37.92,
      '6 de cada': 56.88
    }
  },
  antical: {
    name:'Pack Antical', handle:'pack-antical',
    id:'9580013224275', price:10.06, compareAt:12.50, discount:11, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/BOTELLAANTICAL_-_PRODUCTOFOTO_-_ESP.webp?v=1762345572&width=150',
    frequencies:['3m','6m','12m'],
    variants: { '2':'49714429395283', '4':'49714429428051', '6':'49714429460819' },
    variantPrices: {
      '2': {price:10.06, compareAt:12.50, subPrice:8.95},
      '4': {price:15.00, compareAt:18.00, subPrice:13.95},
      '6': {price:22.17, compareAt:23.50, subPrice:19.95}
    },
    recurringPrices: { '2':4.74, '4':9.40, '6':13.34 }
  },
  desengrasante: {
    name:'Pack Desengrasante', handle:'pack-desengrasante',
    id:'9580409946451', price:10.06, compareAt:12.50, discount:11, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/BOTELLADESENGRASANTE_-_PRODUCTOFOTO_-_ESP_582e5629-43a8-4135-9094-802d44534a23.webp?v=1731090865&width=150',
    frequencies:['3m','6m','12m'],
    variants: { '2':'49722171916627', '4':'49722171949395', '6':'49722171982163' },
    variantPrices: {
      '2': {price:10.06, compareAt:12.50, subPrice:8.95},
      '4': {price:15.00, compareAt:18.00, subPrice:13.95},
      '6': {price:22.17, compareAt:23.50, subPrice:19.95}
    },
    recurringPrices: { '2':4.74, '4':9.40, '6':13.34 }
  },
  limpiacristales: {
    name:'Pack Limpiacristales', handle:'pack-limpiacristales',
    id:'9582894711123', price:10.06, compareAt:12.50, discount:11, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/BOTELLALIMPIACRISTALES_-_PRODUCTOFOTO_-_ESP_84b1495c-af77-4352-aed8-8239800e1d29.webp?v=1731090881&width=150',
    frequencies:['3m','6m','12m'],
    variants: { '2':'49722215268691', '4':'49722215301459', '6':'49722215334227' },
    variantPrices: {
      '2': {price:10.06, compareAt:12.50, subPrice:8.95},
      '4': {price:15.00, compareAt:18.00, subPrice:13.95},
      '6': {price:22.17, compareAt:23.50, subPrice:19.95}
    },
    recurringPrices: { '2':4.74, '4':9.40, '6':13.34 }
  },
  multisuperficies: {
    name:'Pack Multisuperficies', handle:'pack-multisuperficies',
    id:'9582902673747', price:10.06, compareAt:12.50, discount:11, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/BOTELLAMULTISUPERFICIES_-_PRODUCTOFOTO_-_ESP_1.webp?v=1731090899&width=150',
    frequencies:['3m','6m','12m'],
    variants: { '2':'49722247053651', '4':'49722247086419', '6':'49722247119187' },
    variantPrices: {
      '2': {price:10.06, compareAt:12.50, subPrice:8.95},
      '4': {price:15.00, compareAt:18.00, subPrice:13.95},
      '6': {price:22.17, compareAt:23.00, subPrice:19.95}
    },
    recurringPrices: { '2':4.74, '4':9.40, '6':12.00 }
  },
  rec_antical: {
    name:'Recargas Antical', handle:'recarga-antical',
    id:'9583378268499', price:5.51, discount:0, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/BOTELLAANTICAL_-_PRODUCTOFOTO_-_ESP.webp?v=1762345572&width=150',
    frequencies:['3m','6m','12m'],
    variants: { '2':'49823598510419', '4':'49823598543187', '6':'49823598575955' },
    variantPrices: { '2':{price:5.51}, '4':{price:10.93}, '6':{price:15.51} }
  },
  rec_desengrasante: {
    name:'Recargas Desengrasante', handle:'recarga-desengrasante',
    id:'9583394128211', price:5.51, discount:0, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/BOTELLADESENGRASANTE_-_PRODUCTOFOTO_-_ESP_582e5629-43a8-4135-9094-802d44534a23.webp?v=1731090865&width=150',
    frequencies:['3m','6m','12m'],
    variants: { '2':'49824130531667', '4':'49824130564435', '6':'49824130597203' },
    variantPrices: { '2':{price:5.51}, '4':{price:10.93}, '6':{price:15.51} }
  },
  rec_limpiacristales: {
    name:'Recargas Limpiacristales', handle:'recarga-limpiacristales',
    id:'9583400255827', price:5.51, discount:0, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/BOTELLALIMPIACRISTALES_-_PRODUCTOFOTO_-_ESP_84b1495c-af77-4352-aed8-8239800e1d29.webp?v=1731090881&width=150',
    frequencies:['3m','6m','12m'],
    variants: { '2':'49824101302611', '4':'49824101335379', '6':'49824101368147' },
    variantPrices: { '2':{price:5.51}, '4':{price:10.93}, '6':{price:15.51} }
  },
  rec_multisuperficies: {
    name:'Recargas Multisuperficies', handle:'recarga-multisuperficies',
    id:'9583404581203', price:5.51, discount:0, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/BOTELLAMULTISUPERFICIES_-_PRODUCTOFOTO_-_ESP_1.webp?v=1731090899&width=150',
    frequencies:['3m','6m','12m'],
    variants: { '2':'49824071844179', '4':'49824071876947', '6':'49824071909715' },
    variantPrices: { '2':{price:5.51}, '4':{price:10.93}, '6':{price:13.95} }
  },
  rec_perlas: {
    name:'Recarga Perlas Perfumadas', handle:'recarga-tus-perlas-perfumadas',
    id:'9196353192275', price:9.58, discount:17, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/perlas_perfumadas_bosque-convertido-de-png.webp?v=1761677793&width=150',
    frequencies:['30d','60d','90d'],
    hasFragrance:true,
    variants: { 'Lavanda':'51468660179283', 'Bosque Aurora':'48709664112979', 'Floral':'48709664047443' },
    variantImages: {
      'Lavanda':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/Perlas_Perfuamdas_Lavanda-convertido-de-png.webp?v=1761677750&width=150',
      'Bosque Aurora':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/perlas_perfumadas_bosque-convertido-de-png.webp?v=1761677793&width=150',
      'Floral':'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/Perlas_perfumadas_floral-convertido-de-png.webp?v=1761677811&width=150'
    }
  },
  rec_oxiwhite: {
    name:'Recarga Oxi White', handle:'recarga-oxi-white',
    id:'8684803785043', price:11.06, discount:10, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/OXIW_-_PRODUCTOFOTO1_-_ESP-OK-convertido-de-png.webp?v=1764631690&width=150',
    frequencies:['30d','60d','90d','120d'],
    variants: { 'Default':'47552650084691' }
  },
  rec_oxiclean: {
    name:'Recarga Oxi Clean', handle:'recarga-oxi-clean',
    id:'8684822135123', price:11.06, discount:10, category:'Colada',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/OXIC_-_PRODUCTOFOTO1_-_ESP-ok-convertido-de-png.webp?v=1764631674&width=150',
    frequencies:['30d','60d','90d','120d'],
    variants: { 'Default':'47552681836883' }
  },
  rec_acido: {
    name:'Recarga Ácido Cítrico', handle:'recarga-tu-acido-citrico',
    id:'9274786382163', price:11.05, discount:14, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/AC_-_PRODUCTO_-_ESP-OK-convertido-de-png.webp?v=1763380819&width=150',
    frequencies:['30d','60d','90d'],
    variants: { 'Default':'48882780143955' }
  },
  lavmanopolvo: {
    name:'Lavavajillas a Mano en Polvo', handle:'lavavajillas-a-mano-revoluciona-tu-vajilla',
    id:'9502213177683', price:8.58, discount:0, category:'Cocina',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/PACKLAVAMAN_-_PRODUCTOFOTO_productodelano_-_ESP_ok_aa8b7966-4318-4471-9ab4-ae483cbb5a0a.webp?v=1771520975&width=150',
    frequencies:['3m','6m','12m'],
    variants: { 'Default':'49482100900179' }
  },
  rec_lavmano: {
    name:'Recarga Lavavajillas a Mano', handle:'lavavajillas-a-mano-revoluciona-tu-vajilla',
    id:'9502213177683', price:8.58, discount:0, category:'Cocina',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/PACKLAVAMAN_-_PRODUCTOFOTO_productodelano_-_ESP_ok_aa8b7966-4318-4471-9ab4-ae483cbb5a0a.webp?v=1771520975&width=150',
    frequencies:['3m','6m','12m'],
    variants: { 'Default':'49482100900179' }
  },
  acido: {
    name:'Ácido Cítrico', handle:'acido-citrico',
    id:'8705572372819', price:11.05, discount:14, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/AC_-_PRODUCTO_-_ESP-OK-convertido-de-png.webp?v=1763380819&width=150',
    frequencies:['30d','60d','90d'],
    variants: { 'Default': '47609211584851' }
  },
  tierras: {
    name:'Tierras de Sommières', handle:'tierras-de-sommieres',
    id:'8745021243731', price:10.80, discount:0, category:'Hogar',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/tierras-sommiers-greencan-1_f87fa399-a9c3-4389-bdd8-a71313f4c376.webp?v=1754659106&width=150',
    frequencies:[], otp:true,
    variants: { 'Default': '47729714397523' }
  },
  // ── KĒR PRODUCTS (disabled — re-enable when Kēr quiz is reactivated) ──
  /*
  champu: {
    name:'Champú', handle:'champu',
    id:'10128511435091', price:12, discount:8, category:'Cabello',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/CHAMPU_SUNRISE_-_PACK_-_FOTO_-ESP-convertido-de-png.webp?v=1760629810&width=150',
    frequencies:['3m','4m','6m','9m'],
    lavLata:27.5,
    variants: {
      'Recarga / Sunrise':  '51846555009363',
      'Recarga / Detox':    '51846555042131',
      'Recarga / Fenix':    '51846555074899',
      'Kit / Sunrise':      '51929037013331',
      'Kit / Detox':        '51929037046099',
      'Kit / Fenix':        '51929037078867'
    }
  },
  gel: {
    name:'Gel de Ducha', handle:'gel-de-ducha',
    id:'10128514023763', price:11, discount:16, category:'Cuerpo',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/GEL_RADIANCE_-_PACK_-_FOTO_-ESP-convertido-de-png.webp?v=1760630856&width=150',
    frequencies:['3m','4m','6m','9m'],
    lavLata:20.625,
    variants: {
      'Recarga / Radiance':   '51846597804371',
      'Recarga / Clean&Calm': '51846597837139',
      'Kit / Radiance':       '51929870074195',
      'Kit / Clean&Calm':     '51929870106963'
    }
  },
  jabon: {
    name:'Jabón de Manos Cloud', handle:'jabon-de-manos-ker',
    id:'10128516972883', price:11, discount:8, category:'Manos',
    img:'https://cdn.shopify.com/s/files/1/0529/2661/1621/files/JABON_CLOUD_-_PACK_-_FOTO_-ESP-convertido-de-png.webp?v=1760631843&width=150',
    frequencies:['3m','6m','9m','12m'],
    lavLata:82.5,
    variants: {
      'Recarga / Cloud': '51930063831379',
      'Kit / Cloud':     '51930063864147'
    }
  },
  */
};

// ── FREQUENCY LABELS ──
const FREQ_LABELS = {
  '30d':'Tous les mois', '60d':'Tous les 2 mois', '90d':'Tous les 3 mois', '120d':'Tous les 4 mois',
  '3m':'Tous les 3 mois', '4m':'Tous les 4 mois', '6m':'Tous les 6 mois', '8m':'Tous les 8 mois',
  '9m':'Tous les 9 mois', '10m':'Tous les 10 mois', '12m':'Tous les 12 mois', '18m':'Tous les 18 mois',
  '180d':'Tous les 6 mois', '365d':'Tous les 12 mois', 'otp':'Achat unique'
};

// ── CATALAN LOCALE ──
const isCa = typeof Shopify !== 'undefined' && Shopify.locale === 'ca';

if (isCa) {
  Object.assign(FREQ_LABELS, {
    '60d':'Cada 2 mesos', '90d':'Cada 3 mesos', '120d':'Cada 4 mesos',
    '3m':'Cada 3 mesos', '4m':'Cada 4 mesos', '6m':'Cada 6 mesos', '8m':'Cada 8 mesos',
    '9m':'Cada 9 mesos', '10m':'Cada 10 mesos', '12m':'Cada 12 mesos', '18m':'Cada 18 mesos',
    '180d':'Cada 6 mesos', '365d':'Cada 12 mesos'
  });
}

const LANG = {
  // Navigation
  next:             isCa ? 'Següent'                                       : 'Siguiente',
  back:             isCa ? 'Enrere'                                        : 'Atrás',
  skip_email:       isCa ? 'Ara no, gràcies'                               : 'Ahora no, gracias',
  cta_email:        isCa ? 'Veure el meu pla personalitzat ✨'             : 'Ver mi plan personalizado ✨',
  // Header titles
  // title_ker (KĒR disabled): isCa ? 'Dissenya la teva rutina de cura' : 'Diseña tu rutina de cuidado',
  title_hom:        isCa ? 'Dissenya el teu pla de neteja'                 : 'Diseña tu plan de limpieza',
  // Subscription benefits strip
  ben_no_commit:    isCa ? 'Sense permanència'                             : 'Sin permanencia',
  ben_free_ship:    isCa ? 'Enviament gratuït'                             : 'Envío gratis',
  ben_pause:        isCa ? 'Pausa quan vulguis'                            : 'Pausa cuando quieras',
  ben_discount:     isCa ? 'Fins a -22% dte'                               : 'Hasta -22% dto',
  // PDP hero
  ideal_freq:       isCa ? 'La teva freqüència ideal'                      : 'Tu frecuencia ideal',
  first_shipment:   isCa ? '1r enviament'                                  : '1er envío',
  future_refills:   isCa ? 'Properes recàrregues'                          : 'Futuras recargas',
  hero_desc:        isCa ? 'Basat en els teus hàbits, t\'arribarà just quan ho necessites. Càrrega mental zero.' : 'Basado en tus hábitos, te llegará justo cuando lo necesites. Carga mental cero.',
  // Zero-load badge
  zl_title:         isCa ? 'Càrrega mental zero'                           : 'Carga mental cero',
  zl_desc:          isCa ? 'Tot arriba a casa just quan ho necessites. Sense pensar, sense quedar-te sense res.' : 'Todo llega a casa justo cuando lo necesitas. Sin pensar, sin quedarte sin nada.',
  // Results header
  badge_hom:        isCa ? 'El teu pla de neteja'                          : 'Tu plan de limpieza',
  // badge_ker (KĒR disabled): isCa ? 'La teva rutina de cura' : 'Tu rutina de cuidado',
  results_title_pdp:isCa ? 'Completa el teu pla'                           : 'Completa tu plan',
  results_title:    isCa ? 'El teu pla personalitzat'                      : 'Tu plan personalizado',
  products_for_you: isCa ? ' productes seleccionats per a tu'              : ' productos seleccionados para ti',
  // Cross-sell section
  crosssell_title:  isCa ? 'Completa la teva rutina de neteja'             : 'Completa tu rutina de limpieza',
  crosssell_desc:   isCa ? 'Tot arriba just quan ho necessites. Càrrega mental zero.' : 'Todo llega justo cuando lo necesitas. Carga mental cero.',
  // Shipment boxes
  otp_label:        isCa ? 'Compra única'                                  : 'Compra única',
  per_shipment:     isCa ? '€/enviament'                                   : '€/envío',
  product_singular: isCa ? ' producte'                                     : ' producto',
  product_plural:   isCa ? ' productes'                                    : ' productos',
  days_fallback:    isCa ? ' dies'                                         : ' jours',
  months_fallback:  isCa ? ' mesos'                                        : ' mois',
  // Summary
  your_plan:        isCa ? 'El teu pla'                                    : 'Tu plan',
  summary_title:    isCa ? 'La teva rutina personalitzada'                  : 'Tu rutina personalizada',
  savings:          isCa ? 'Estalvies '                                    : 'Ahorras ',
  savings_suffix:   isCa ? '€ amb la teva subscripció'                     : '€ con tu suscripción',
  future_refills_s: isCa ? 'Properes recàrregues: '                        : 'Futuras recargas: ',
  // Cart CTA
  add_to_cart:      isCa ? 'Afegir tot a la cistella 🛒'                   : 'Añadir todo al carrito 🛒',
  adding:           isCa ? 'Afegint...'                                    : 'Añadiendo...',
  add_to_cart_err:  isCa ? 'Afegir a la cistella'                          : 'Añadir al carrito',
  cart_error:       isCa ? 'Error en afegir a la cistella: '               : 'Error al añadir al carrito: ',
  // Fragrance
  select_fragrance: isCa ? 'Selecciona fragància:'                         : 'Selecciona fragancia:',
  // Badges
  no_subscription:  isCa ? 'Sense subscripció'                             : 'Sin suscripción',
  // Savings label
  save_pct:         isCa ? 'Estalvia '                                     : 'Ahorra ',
  // Recurring breakdown
  next_shipments:   isCa ? 'Els teus propers '                             : 'Tus próximos ',
  shipments_label:  isCa ? ' enviaments'                                   : ' envíos',
  month_label:      isCa ? 'Mes '                                          : 'Mes ',
  // Cross-quiz (KĒR cross-sell disabled — re-enable when Kēr quiz is reactivated)
  // cross_ker_text: isCa ? '🧴 Coneixes <strong>Natulim Kēr</strong>? Xampú, gel i sabó natural en llaunes infinites.' : '🧴 ¿Conoces <strong>Natulim Kēr</strong>? Champú, gel y jabón natural en latas infinitas.',
  // cross_ker_cta:  isCa ? 'Fer el Quiz Kēr →' : 'Hacer el Quiz Kēr →',
  cross_hom_text:   isCa ? '🏠 Ja tens el teu <strong>pla de neteja</strong> de la llar?' : '🏠 ¿Ya tienes tu <strong>plan de limpieza</strong> del hogar?',
  cross_hom_cta:    isCa ? 'Fer el Quiz Hom →'                             : 'Hacer el Quiz Hom →'
};

// ── CATALAN QUESTION TRANSLATIONS ──
const TRANS_CA_Q = {
  P1: {
    q: 'Quantes persones viviu a casa?', sub: 'Per calcular el teu consum',
    opts: { '1-2':'1-2 persones', '3-4':'3-4 persones', '5+':'5+ persones' }
  },
  P2: {
    q: 'Hi ha alguna cosa especial a casa teva?', sub: 'Selecciona tot el que apliqui',
    opts: { 'peques':'Peques a casa', 'mascota':'Mascota/es', 'actividad':'Molta activitat / esport', 'casa_grande':'Casa gran (+100m²)', 'nada':'Res d\'especial' },
    descs: { 'peques':'Necessites neteja més suau i potent', 'mascota':'Pèls, taques i olors extra', 'actividad':'Roba amb taques difícils', 'casa_grande':'Més superfície per netejar' }
  },
  P2_MASCOTA: {
    q: 'Quina mascota tens?', sub: '',
    opts: { 'perro':'Gos', 'gato':'Gat', 'ambos':'Ambdós' }
  },
  P2_ARENA: {
    q: 'Amb quina freqüència canvies l\'arena?', sub: '',
    opts: { 'diario':'Cada dia', '2-3dias':'Cada 2-3 dies', 'semanal':'1x setmana', 'no_arena':'No faig servir arena' }
  },
  P3: {
    q: 'Quant t\'agrada que faci olor la roba?', sub: 'Intensitat de les Perles Perfumades',
    opts: { '+++':'Molt intensa', '++':'Intensa', '+':'Suau', 'sin':'Sense fragància' },
    descs: { '+++':'30g/bugada', '++':'20g/bugada', '+':'10g/bugada' }
  },
  P4: { q: 'Quantes bugades fas per setmana?', sub: 'Totes les bugades de la teva llar', unit: 'bugades/setmana' },
  P5: {
    q: 'Tens rentavaixelles?', sub: '',
    opts: { 'si':'Sí, tinc rentavaixelles', 'no':'No, rento tot a mà' }
  },
  P5a: { q: 'Quants cicles de rentavaixelles per setmana?', sub: '', unit: 'cicles/setmana' },
  P5b: { q: 'Quantes vegades rentes a mà al dia?', sub: 'Plats, gots, paelles...', unit: 'vegades/dia' },
  PH: {
    q: 'Amb quina freqüència neteges la teva casa a fons?', sub: 'Terres, superfícies, banys...',
    opts: { 'diario':'Tots els dies', '3x_sem':'2-3 vegades per setmana', '1x_sem':'1 vegada per setmana' }
  },
  PP: {
    q: 'Com descriuries el teu tipus de pell?', sub: 'Per personalitzar la teva recomanació',
    opts: { 'normal':'Normal', 'sensible':'Sensible', 'atopica':'Atòpica', 'no_se':'No ho sé' }
  },
  // ── KĒR Catalan question translations (disabled — re-enable when Kēr quiz is reactivated) ──
  /*
  KP1: { q: 'Quantes persones fareu servir els productes?', sub: 'Xampú, gel i sabó', unit: 'persones' },
  KP_PIEL: {
    q: 'Com descriuries el teu tipus de pell?', sub: 'Per al gel de dutxa ideal',
    opts: { 'normal':'Normal', 'sensible':'Sensible', 'atopica':'Atòpica', 'no_se':'No ho sé' }
  },
  KP_CAB: {
    q: 'Quin tipus de cabell tens?', sub: '',
    opts: { 'grueso':'Gruixut', 'fino':'Fi' }
  },
  KP_EST: {
    q: 'Quin és l\'estat del teu cabell?', sub: 'Selecciona tot el que apliqui',
    opts: { 'normal':'Normal / Sa', 'seco':'Sec o danyat', 'graso':'Gras', 'rizado':'Cabell arrissat', 'tenido':'Tenyit' }
  },
  KP2a: { q: 'Amb quina freqüència et rentes el cabell?', sub: '', unit: 'vegades/setmana' },
  KP2b: { q: 'Amb quina freqüència et dutxes?', sub: '', unit: 'dutxes/setmana' },
  KP2c: {
    q: 'Quantes vegades al dia us renteu les mans?', sub: 'Entre totes les persones',
    opts: { '1-3':'1-3 vegades', '4-6':'4-6 vegades', '7-10':'7-10 vegades', '+10':'Més de 10' }
  },
  KH: {
    q: 'Amb quina freqüència neteges la teva casa?', sub: 'Per suggerir-te productes de neteja',
    opts: { 'diario':'Tots els dies', '3x_sem':'2-3 vegades/setmana', '1x_sem':'1 vegada/setmana' }
  },
  */
  EMAIL: { q: 'Vols que guardem el teu pla?', sub: 'El teu email queda protegit. És 100% opcional.' }
};

function tQ(stepId) {
  if (!isCa) return Q[stepId];
  var base = Q[stepId];
  var tr = TRANS_CA_Q[stepId];
  if (!tr) return base;
  var merged = Object.assign({}, base, {
    q: tr.q || base.q,
    sub: tr.sub !== undefined ? tr.sub : base.sub
  });
  if (tr.unit) merged.unit = tr.unit;
  if (tr.opts && base.opts) {
    merged.opts = base.opts.map(function(o) {
      var out = Object.assign({}, o);
      if (tr.opts[o.v]) out.l = tr.opts[o.v];
      if (tr.descs && tr.descs[o.v]) out.d = tr.descs[o.v];
      return out;
    });
  }
  return merged;
}

// ── STATE ──
let quizType = 'hom';
let mode = 'landing_hom';
let currentStep = 0;
let answers = {};
let flow = [];
let resultItems = [];
const selectedFragrances = {};

// ── QUESTION DEFINITIONS ──
const Q = {
  P1: { id:'P1', q:'¿Cuántas personas vivís en casa?', sub:'Para calcular tu consumo', type:'radio',
    opts:[{v:'1-2',e:'👫',l:'1-2 personas'},{v:'3-4',e:'👨‍👩‍👧',l:'3-4 personas'},{v:'5+',e:'👨‍👩‍👧‍👦',l:'5+ personas'}]},
  P2: { id:'P2', q:'¿Hay algo especial en tu hogar?', sub:'Selecciona todo lo que aplique', type:'checkbox',
    opts:[
      {v:'peques',e:'👶',l:'Peques en casa',d:'Necesitas limpieza más suave y potente'},
      {v:'mascota',e:'🐾',l:'Mascota/s',d:'Pelos, manchas y olores extra'},
      {v:'actividad',e:'🏃',l:'Mucha actividad / deporte',d:'Ropa con manchas difíciles'},
      {v:'casa_grande',e:'🏡',l:'Casa grande (+100m²)',d:'Más superficie para limpiar'},
      {v:'nada',e:'✨',l:'Nada especial'}
    ]},
  P2_MASCOTA: { id:'P2_MASCOTA', q:'¿Qué mascota tienes?', sub:'', type:'radio',
    opts:[{v:'perro',e:'🐶',l:'Perro'},{v:'gato',e:'🐱',l:'Gato'},{v:'ambos',e:'🐶🐱',l:'Ambos'}]},
  P2_ARENA: { id:'P2_ARENA', q:'¿Con qué frecuencia cambias la arena?', sub:'', type:'radio',
    opts:[{v:'diario',e:'📅',l:'Cada día'},{v:'2-3dias',e:'📆',l:'Cada 2-3 días'},{v:'semanal',e:'🗓️',l:'1x semana'},{v:'no_arena',e:'🌿',l:'No uso arena'}]},
  P3: { id:'P3', q:'¿Cuánto te gusta que huela la ropa?', sub:'Intensidad de las Perlas Perfumadas', type:'radio',
    opts:[{v:'+++',e:'🌸🌸🌸',l:'Muy intensa',d:'30g/lavado'},{v:'++',e:'🌸🌸',l:'Intensa',d:'20g/lavado'},{v:'+',e:'🌸',l:'Suave',d:'10g/lavado'},{v:'sin',e:'🍃',l:'Sin fragancia'}]},
  P4: { id:'P4', q:'¿Cuántas lavadoras pones por semana?', sub:'Todas las coladas de tu hogar', type:'stepper', min:1, max:14, def:4, unit:'lavadoras/semana' },
  P5: { id:'P5', q:'¿Tienes lavavajillas?', sub:'', type:'radio',
    opts:[{v:'si',e:'🫧',l:'Sí, tengo lavavajillas'},{v:'no',e:'🧽',l:'No, lavo todo a mano'}]},
  P5a: { id:'P5a', q:'¿Cuántos ciclos de lavavajillas por semana?', sub:'', type:'stepper', min:1, max:14, def:5, unit:'ciclos/semana' },
  P5b: { id:'P5b', q:'¿Cuántas veces lavas a mano al día?', sub:'Platos, vasos, sartenes...', type:'stepper', min:1, max:10, def:3, unit:'veces/día' },
  PH: { id:'PH', q:'¿Con qué frecuencia limpias tu casa a fondo?', sub:'Suelos, superficies, baños...', type:'radio',
    opts:[{v:'diario',e:'🏠',l:'Todos los días'},{v:'3x_sem',e:'🧹',l:'2-3 veces por semana'},{v:'1x_sem',e:'✨',l:'1 vez por semana'}]},
  PP: { id:'PP', q:'¿Cómo describirías tu tipo de piel?', sub:'Para personalizar tu recomendación', type:'radio',
    opts:[{v:'normal',e:'😊',l:'Normal'},{v:'sensible',e:'🤍',l:'Sensible'},{v:'atopica',e:'🩹',l:'Atópica'},{v:'no_se',e:'🤔',l:'No lo sé'}]},
  // ── KĒR question definitions (disabled — re-enable when Kēr quiz is reactivated) ──
  /*
  KP1: { id:'KP1', q:'¿Cuántas personas usaréis los productos?', sub:'Champú, gel y jabón', type:'stepper', min:1, max:5, def:1, unit:'personas' },
  KP_PIEL: { id:'KP_PIEL', q:'¿Cómo describirías tu tipo de piel?', sub:'Para el gel de ducha ideal', type:'radio',
    opts:[{v:'normal',e:'😊',l:'Normal'},{v:'sensible',e:'🤍',l:'Sensible'},{v:'atopica',e:'🩹',l:'Atópica'},{v:'no_se',e:'🤔',l:'No lo sé'}]},
  KP_CAB: { id:'KP_CAB', q:'¿Qué tipo de cabello tienes?', sub:'', type:'radio',
    opts:[{v:'grueso',e:'💪',l:'Grueso'},{v:'fino',e:'🪶',l:'Fino'}]},
  KP_EST: { id:'KP_EST', q:'¿Cuál es el estado de tu cabello?', sub:'Selecciona todo lo que aplique', type:'checkbox',
    opts:[{v:'normal',e:'✨',l:'Normal / Sano'},{v:'seco',e:'🏜️',l:'Seco o dañado'},{v:'graso',e:'💧',l:'Graso'},{v:'rizado',e:'🌀',l:'Cabello rizado'},{v:'tenido',e:'🎨',l:'Teñido'}]},
  KP2a: { id:'KP2a', q:'¿Con qué frecuencia te lavas el cabello?', sub:'', type:'stepper', min:1, max:7, def:3, unit:'veces/semana' },
  KP2b: { id:'KP2b', q:'¿Con qué frecuencia te duchas?', sub:'', type:'stepper', min:1, max:14, def:7, unit:'duchas/semana' },
  KP2c: { id:'KP2c', q:'¿Cuántas veces al día os laváis las manos?', sub:'Entre todas las personas', type:'radio',
    opts:[{v:'1-3',e:'🤲',l:'1-3 veces'},{v:'4-6',e:'🧼',l:'4-6 veces'},{v:'7-10',e:'💦',l:'7-10 veces'},{v:'+10',e:'🚿',l:'Más de 10'}]},
  KH: { id:'KH', q:'¿Con qué frecuencia limpias tu casa?', sub:'Para sugerirte productos de limpieza', type:'radio',
    opts:[{v:'diario',e:'🏠',l:'Todos los días'},{v:'3x_sem',e:'🧹',l:'2-3 veces/semana'},{v:'1x_sem',e:'✨',l:'1 vez/semana'}]},
  */
  EMAIL: { id:'EMAIL', q:'¿Quieres que guardemos tu plan?', sub:'Tu email queda protegido. Es 100% opcional.', type:'email' }
};

// ── DYNAMIC DATA FETCHING ──
// Fetch live product data from Shopify AJAX API (same as portal)
function _fetchProductData() {
  // KĒR disabled: quizType is always 'hom' — always load HOM categories
  // const allowed = quizType === 'ker' ? ['Cabello', 'Cuerpo', 'Manos'] : ['Colada', 'Cocina', 'Hogar'];
  const allowed = ['Colada', 'Cocina', 'Hogar'];
  const promises = [];
  let fetched = 0, failed = 0, plansFetched = 0;
  Object.keys(PRODUCTS).forEach(function(key) {
    const prod = PRODUCTS[key];
    if (!prod.handle) return;
    if (!allowed.includes(prod.category)) return;
    const p = fetch('/products/' + prod.handle + '.js')
      .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(data => {
        const p = data;
        // Update product data with live values
        if (p.title) prod.name = p.title;
        if (p.featured_image) prod.img = p.featured_image + '&width=150';
        // Update variant IDs
        if (p.variants && p.variants.length > 0) {
          const newVariants = {};
          p.variants.forEach(v => { newVariants[v.title || 'Default'] = String(v.id); });
          prod.variants = newVariants;
          // Update price from first variant
          const fv = p.variants[0];
          if (fv.price) prod.price = fv.price / 100;
          if (fv.compare_at_price) prod.compareAt = fv.compare_at_price / 100;
          // Sub price from selling plan allocations
          if (fv.selling_plan_allocations && fv.selling_plan_allocations.length > 0) {
            const spa = fv.selling_plan_allocations[0];
            if (spa.per_delivery_price != null) {
              prod.subPrice = parseFloat(spa.per_delivery_price) / 100;
              prod.subCompareAt = spa.compare_at_price ? parseFloat(spa.compare_at_price) / 100 : prod.price;
            }
            // Multi-variant sub prices
            if (p.variants.length > 1) {
              prod.variantSubPrices = {};
              p.variants.forEach(vv => {
                if (vv.selling_plan_allocations && vv.selling_plan_allocations.length > 0) {
                  prod.variantSubPrices[vv.title || 'Default'] = parseFloat(vv.selling_plan_allocations[0].per_delivery_price) / 100;
                }
              });
            }
          }
          // Variant prices
          if (p.variants.length > 1) {
            const vp = {};
            p.variants.forEach(vv => {
              vp[vv.title || 'Default'] = {
                price: vv.price / 100,
                compareAt: vv.compare_at_price ? vv.compare_at_price / 100 : null,
                subPrice: (vv.selling_plan_allocations && vv.selling_plan_allocations[0]) ? parseFloat(vv.selling_plan_allocations[0].per_delivery_price) / 100 : null
              };
            });
            prod.variantPrices = vp;
          }
        }
        // Update Shopify product ID
        if (p.id) prod.id = String(p.id);
        // Extract Selling Plan IDs from selling_plan_groups (update SELLING_PLANS dynamically)
        if (p.selling_plan_groups && p.selling_plan_groups.length > 0) {
          const spMap = {};
          // For multi-variant, build per-variant map
          if (p.variants.length > 1) {
            // Build master: shopify_selling_plan_id → selling_plan_id
            const masterBySpId = {};
            p.selling_plan_groups.forEach(g => {
              if (!g.selling_plans) return;
              g.selling_plans.forEach(sp => {
                let freqKey = null;
                (sp.options || []).forEach(opt => {
                  if (opt.name === 'Order Frequency and Unit' && opt.value) {
                    const parts = opt.value.split('-');
                    if (parts.length === 2) freqKey = parts[0] + (parts[1] === 'day' ? 'd' : parts[1] === 'month' ? 'm' : parts[1][0]);
                  }
                });
                if (freqKey && sp.id) masterBySpId[String(sp.id)] = freqKey;
              });
            });
            // Per-variant selling plans
            const variantSP = {};
            p.variants.forEach(vv => {
              const vid = String(vv.id);
              const vPlans = {};
              (vv.selling_plan_allocations || []).forEach(spa => {
                const fk = masterBySpId[String(spa.selling_plan_id)];
                if (fk) vPlans[fk] = String(spa.selling_plan_id);
              });
              if (Object.keys(vPlans).length > 0) variantSP[vid] = vPlans;
            });
            if (Object.keys(variantSP).length > 0) {
              SELLING_PLANS[key] = variantSP;
              SELLING_PLANS[key]._multiVariant = true;
              plansFetched++;
            }
          } else {
            // Single variant — flat map
            p.selling_plan_groups.forEach(g => {
              if (!g.selling_plans) return;
              g.selling_plans.forEach(sp => {
                let freqKey = null;
                (sp.options || []).forEach(opt => {
                  if (opt.name === 'Order Frequency and Unit' && opt.value) {
                    const parts = opt.value.split('-');
                    if (parts.length === 2) freqKey = parts[0] + (parts[1] === 'day' ? 'd' : parts[1] === 'month' ? 'm' : parts[1][0]);
                  }
                });
                if (freqKey && sp.id) spMap[freqKey] = String(sp.id);
              });
            });
            if (Object.keys(spMap).length > 0) {
              SELLING_PLANS[key] = spMap;
              plansFetched++;
            }
          }
        }
        fetched++;
      })
      .catch(err => {
        failed++;
        dbg('  AJAX fail for ' + key + ' (' + prod.handle + '): ' + err.message);
      });
    promises.push(p);
  });
  return Promise.all(promises).then(() => {
    dbg('Web Quiz: Products refreshed — ' + fetched + ' ok, ' + failed + ' failed, ' + plansFetched + ' with live selling plans');
  });
}

// ── QUIZ ID + SESSION TRACKING ──
let _quizId = '';
let _quizSessionId = '';
let _quizSessionNumber = 0;
function _initQuizIds() {
  try {
    _quizId = localStorage.getItem('ntl_quiz_id') || '';
    if (!_quizId) {
      _quizId = 'ntl_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('ntl_quiz_id', _quizId);
    }
    _quizSessionNumber = parseInt(localStorage.getItem('ntl_quiz_session_n') || '0') + 1;
    localStorage.setItem('ntl_quiz_session_n', String(_quizSessionNumber));
    _quizSessionId = _quizId + '_' + _quizSessionNumber;
    dbg('Web Quiz: quiz_id=' + _quizId + ' session=' + _quizSessionId);
  } catch(e) { dbg('Quiz ID init error: ' + e.message); }
}

// ── GOOGLE SHEET LOGGING ──
const QUIZ_LOG_WEBHOOK = 'https://script.google.com/macros/s/AKfycbyFLu8IFddTM5drqNfSlTYJ7F6eVErXp3Dn6yb_zRn_KtqoxZPFtrakwvwBoXkvR8Hsrg/exec';
const DISCORD_ALERT_WEBHOOK = 'https://discord.com/api/webhooks/1276553120842911796/uOyfFXQ3YoTOVTPA-kJNXFfIvtI011VrrWvMwb-lCwoWKJWvC29bzLs0CgPUdI6VH3T7';
let _discordAlertSent = false; // max 1 alert per session

function _sendDiscordAlert(message) {
  if (_discordAlertSent) return;
  _discordAlertSent = true;
  try {
    fetch(DISCORD_ALERT_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content: '🚨 **Quiz Analytics Alert**\n' + message + '\nURL: ' + window.location.href })
    });
  } catch(e) { /* silent */ }
}
let _quizStartTime = 0;
let _quizCompleted = false;

function _logToSheet(productRows) {
  if (!QUIZ_LOG_WEBHOOK) return;
  const fragMap = {'+++':'Alta','++':'Media','+':'Baja','sin':'Sin fragancia'};
  // Detect quiz mode and entry point
  var _quizMode = 'general';
  var _entryPDP = '';
  try {
    var sectionEl = document.querySelector('[data-quiz-product]');
    if (sectionEl) { _quizMode = 'pdp'; _entryPDP = sectionEl.getAttribute('data-quiz-product') || ''; }
    else if (window.__quizProduct) { _quizMode = 'pdp'; _entryPDP = window.__quizProduct; }
  } catch(e) {}
  var _entryPoint = 'direct';
  try {
    var ref = document.referrer || '';
    var params = new URLSearchParams(window.location.search);
    if (params.get('utm_medium') === 'email') _entryPoint = 'email';
    else if (params.get('utm_medium') === 'cpc' || params.get('gclid')) _entryPoint = 'ad';
    else if (ref.includes('/products/')) _entryPoint = 'pdp';
    else if (ref.includes('/collections/')) _entryPoint = 'collection';
    else if (ref.match(/\/$/) || ref.includes('natulim.com') && !ref.includes('/products/') && !ref.includes('/collections/')) _entryPoint = 'home';
  } catch(e) {}
  var _device = (window.innerWidth < 768) ? 'mobile' : 'desktop';

  const baseData = {
    quiz_id: _quizId,
    quiz_session_id: _quizSessionId,
    quiz_session_number: _quizSessionNumber,
    email: answers.EMAIL || '',
    source: 'web',
    quiz_type: quizType,
    quiz_mode: _quizMode,
    entry_pdp: _entryPDP,
    entry_point: _entryPoint,
    device: _device,
    household: answers.P1 || '',
    has_kids: (answers.P2 || []).includes('peques'),
    has_pet: (answers.P2 || []).includes('mascota'),
    pet_type: answers.P2_MASCOTA || '',
    arena_freq: answers.P2_ARENA || '',
    active_lifestyle: (answers.P2 || []).includes('actividad'),
    large_home: (answers.P2 || []).includes('casa_grande'),
    fragrance: fragMap[answers.P3] || answers.P3 || '',
    washes_per_week: parseInt(answers.P4) || 0,
    has_dishwasher: answers.P5 === 'si',
    dishwasher_cycles: parseInt(answers.P5a) || 0,
    hand_washes_per_day: parseInt(answers.P5b) || 0,
    cleaning_freq: answers.PH || '',
    skin_type: answers.PP || '',
    quiz_status: 'success',
    error_detail: ''
  };
  const rows = productRows.map(p => {
    const row = Object.assign({}, baseData, p);
    return row;
  });
  fetch(QUIZ_LOG_WEBHOOK, {
    method: 'POST',
    mode: 'no-cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ rows: rows })
  }).catch(function(e) {
    dbg('Sheet log error: ' + e.message);
    _sendDiscordAlert('⚠️ **Google Sheets no disponible** — fallo de red al enviar datos del quiz. Rows perdidas: ' + rows.length + '. Error: ' + e.message);
  });
}

// ── KLAVIYO INTEGRATION ──
function _klavIdentify(props) {
  try {
    const kl = window.klaviyo;
    if (!kl) {
      dbg('Klaviyo not available');
      _sendDiscordAlert('⚠️ **Klaviyo no disponible** — `window.klaviyo` es null. El script de Klaviyo no cargó. Datos del quiz NO enviados a Klaviyo.');
      return;
    }
    if (answers.EMAIL) props.email = answers.EMAIL;
    props['$source'] = 'Quiz Web';
    dbg('Klaviyo identify: ' + Object.keys(props).join(', '));
    kl.identify(props);
  } catch(e) {
    dbg('Klaviyo identify error: ' + e.message);
    _sendDiscordAlert('⚠️ **Error en Klaviyo identify**: ' + e.message);
  }
}

function _klavTrack(event, props) {
  try {
    const kl = window.klaviyo;
    if (!kl) return; // already alerted in _klavIdentify
    dbg('Klaviyo track: ' + event);
    kl.track(event, props || {});
  } catch(e) {
    dbg('Klaviyo track error: ' + e.message);
    _sendDiscordAlert('⚠️ **Error en Klaviyo track** (`' + event + '`): ' + e.message);
  }
}

function _klavBuildProfile() {
  const p2 = answers.P2 || [];
  return {
    'Quiz > Dónde lo hizo': 'web',
    'Quiz > Tipo de quiz': quizType,
    'Quiz > Personas en casa': answers.P1 || '',
    'Quiz > Tiene niños en casa': p2.includes('peques'),
    'Quiz > Tiene mascota': p2.includes('mascota'),
    'Quiz > Vida activa / deporte': p2.includes('actividad'),
    'Quiz > Casa grande (+100m²)': p2.includes('casa_grande'),
    'Quiz > Preferencia de fragancia': answers.P3 || '',
    'Quiz > Lavadoras por semana': parseInt(answers.P4) || 0,
    'Quiz > Tiene lavavajillas': answers.P5 === 'si',
    'Quiz > Ciclos lavavajillas por semana': parseInt(answers.P5a) || 0,
    'Quiz > Lavados a mano por día': parseInt(answers.P5b) || 0,
    'Quiz > Frecuencia limpieza hogar': answers.PH || '',
    'Quiz > Tipo de mascota': answers.P2_MASCOTA || '',
    'Quiz > Frecuencia cambio arena': answers.P2_ARENA || '',
    'Quiz > Tipo de piel': answers.PP || ''
  };
}

// ── FLOWS ──
const FLOWS = {
  landing_hom: ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_detergente:   ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_oxis:         ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_perlas:       ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_pastillas:    ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_lavmano:      ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_friegasuelos: ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_flisflis:     ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_antical:         ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_desengrasante:   ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_limpiacristales: ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_multisuperficies:['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_rec_antical:         ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_rec_desengrasante:   ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_rec_limpiacristales: ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_rec_multisuperficies:['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_rec_perlas:          ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_rec_oxiwhite:        ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_rec_oxiclean:        ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_rec_acido:           ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  pdp_lavmanopolvo:        ['P1','P2','P3','P4','P5','PH','PP','EMAIL','RESULTS'],
  // ── KĒR flows (disabled — re-enable when Kēr quiz is reactivated) ──
  // landing_ker: ['KP1','KP_PIEL','KP_CAB','KP_EST','KP2a','KP2b','KP2c','KH','EMAIL','RESULTS'],
  // pdp_champu:  ['KP1','KP_PIEL','KP_CAB','KP_EST','KP2a','KP2b','KP2c','KH','EMAIL','RESULTS'],
  // pdp_gel:     ['KP1','KP_PIEL','KP_CAB','KP_EST','KP2a','KP2b','KP2c','KH','EMAIL','RESULTS'],
  // pdp_jabon:   ['KP1','KP_PIEL','KP_CAB','KP_EST','KP2a','KP2b','KP2c','KH','EMAIL','RESULTS'],
};

const MODES = {
  hom: [
    {v:'landing_hom',l:'Landing completo'},{v:'pdp_detergente',l:'PDP Detergente'},
    {v:'pdp_oxis',l:'PDP Oxis'},{v:'pdp_perlas',l:'PDP Perlas'},
    {v:'pdp_pastillas',l:'PDP Pastillas'},{v:'pdp_lavmano',l:'PDP Lavavajillas Mano'},
    {v:'pdp_friegasuelos',l:'PDP Friegasuelos'},{v:'pdp_flisflis',l:'PDP Flis-Flis'},
    {v:'pdp_antical',l:'PDP Antical'},{v:'pdp_desengrasante',l:'PDP Desengrasante'},
    {v:'pdp_limpiacristales',l:'PDP Limpiacristales'},{v:'pdp_multisuperficies',l:'PDP Multisuperficies'},
    {v:'pdp_rec_antical',l:'PDP Rec.Antical'},{v:'pdp_rec_desengrasante',l:'PDP Rec.Desengrasante'},
    {v:'pdp_rec_limpiacristales',l:'PDP Rec.Limpiacristales'},{v:'pdp_rec_multisuperficies',l:'PDP Rec.Multisuperficies'},
    {v:'pdp_rec_perlas',l:'PDP Rec.Perlas'},{v:'pdp_rec_oxiwhite',l:'PDP Rec.OxiWhite'},
    {v:'pdp_rec_oxiclean',l:'PDP Rec.OxiClean'},{v:'pdp_rec_acido',l:'PDP Rec.Ácido'},
    {v:'pdp_lavmanopolvo',l:'PDP LavMano Polvo'}
  ],
  // ── KĒR modes (disabled — re-enable when Kēr quiz is reactivated) ──
  // ker: [
  //   {v:'landing_ker',l:'Landing completo'},{v:'pdp_champu',l:'PDP Champú'},
  //   {v:'pdp_gel',l:'PDP Gel'},{v:'pdp_jabon',l:'PDP Jabón'}
  // ]
};

// ════════════════════════════════════════════════════════════
// FREQUENCY MATCHING
// ════════════════════════════════════════════════════════════

function snapToFrequency(rawDays, productKey) {
  const prod = PRODUCTS[productKey];
  if (!prod || prod.otp) return {freq:'otp', label:'Compra única', qty:1};
  const freqs = prod.frequencies;
  if (freqs.length === 0) return {freq:'otp', label:'Compra única', qty:1};
  if (freqs.length === 1) return {freq:freqs[0], label:FREQ_LABELS[freqs[0]], qty:1};
  const toDays = f => {
    if (f.endsWith('d')) return parseInt(f);
    if (f.endsWith('m')) return parseInt(f) * 30;
    return 30;
  };
  const freqDays = freqs.map(f => ({freq:f, days:toDays(f)}));
  freqDays.sort((a,b) => a.days - b.days);
  if (rawDays >= freqDays[freqDays.length-1].days * 0.8) {
    const best = freqDays[freqDays.length-1];
    return {freq:best.freq, label:FREQ_LABELS[best.freq], qty:1};
  }
  for (let i = freqDays.length - 1; i >= 0; i--) {
    if (rawDays >= freqDays[i].days * 0.75) {
      return {freq:freqDays[i].freq, label:FREQ_LABELS[freqDays[i].freq], qty:1};
    }
  }
  const shortest = freqDays[0];
  return {freq:shortest.freq, label:FREQ_LABELS[shortest.freq], qty:1};
}

// ════════════════════════════════════════════════════════════
// CALCULATION ENGINE
// ════════════════════════════════════════════════════════════

function calcDet40(lavSem) { return snapToFrequency((20 / lavSem) * 7, 'det40'); }
function calcDet360(lavSem) {
  if (lavSem >= 8) return {freq:'10m', label:FREQ_LABELS['10m'], qty:1};
  if (lavSem >= 5) return {freq:'12m', label:FREQ_LABELS['12m'], qty:1};
  return {freq:'18m', label:FREQ_LABELS['18m'], qty:1};
}
function calcOxisNormal(lavSem) { return snapToFrequency((500/15 / lavSem) * 7, 'oxis'); }
function calcOxis3070(lavSem) { return snapToFrequency((500/15 / lavSem) * 7, 'oxis'); }
function calcPerlas(lavSem, intens) {
  const grams = intens==='+++'?30:intens==='++'?20:10;
  return snapToFrequency((300 / grams / lavSem) * 7, 'perlas');
}
function calcPastillas(ciclosSem) { return snapToFrequency((60 / ciclosSem) * 7, 'pastillas'); }
function calcLavMano(lavDia) {
  const meses = (250 / lavDia) / 30;
  const intervals = [3, 6, 12]; // Only 3m, 6m, 12m available
  const freqM = intervals.find(m => m >= meses) || 12;
  const key = freqM + 'm';
  return {freq:key, label:FREQ_LABELS[key], qty:1};
}
function calcFriegasuelos(freq, grande) {
  const fregados = grande ? 15 : 30;
  const fregSem = freq==='diario'?3:freq==='3x_sem'?2:1;
  const dias = (fregados / fregSem) * 7;
  if (dias >= 270) return {freq:'12m', label:FREQ_LABELS['12m'], qty:1};
  if (dias >= 135) return {freq:'6m', label:FREQ_LABELS['6m'], qty:1};
  return {freq:'3m', label:FREQ_LABELS['3m'], qty:1};
}
function calcFlisFlis(freq, grande) {
  const map = { diario:{n:'3m',g:'6m'}, '3x_sem':{n:'6m',g:'12m'}, '1x_sem':{n:'12m',g:'12m'} };
  const f = map[freq] || map['3x_sem'];
  const chosen = grande ? f.g : f.n;
  const variant = grande ? '4 de cada' : '2 de cada';
  return {freq:chosen, label:FREQ_LABELS[chosen], qty:1, variant};
}
function calcIndividualHogar(freq, grande) {
  const map = { diario:{n:'3m',g:'6m'}, '3x_sem':{n:'6m',g:'12m'}, '1x_sem':{n:'12m',g:'12m'} };
  const f = map[freq] || map['3x_sem'];
  const chosen = grande ? f.g : f.n;
  const variant = grande ? '4' : '2';
  return {freq:chosen, label:FREQ_LABELS[chosen], qty:1, variant};
}
function calcQuitamanchas(peques, mascota) {
  if (peques||mascota) return {freq:'8m', label:'Tous les 8 mois', qty:1};
  return {freq:'12m', label:FREQ_LABELS['12m'], qty:1};
}
function calcAcido() { return snapToFrequency(90, 'acido'); }
// ── KĒR calc functions (disabled — re-enable when Kēr quiz is reactivated) ──
// function calcChampu(personas, lavSem) { return snapToFrequency((27.5 / (lavSem * personas)) * 7, 'champu'); }
// function calcGel(personas, duchasSem) { return snapToFrequency((20.625 / (duchasSem * personas)) * 7, 'gel'); }
// function calcJabon(personas, rangeStr) {
//   const lavDia = {'1-3':2, '4-6':5, '7-10':8.5, '+10':12}[rangeStr] || 5;
//   return snapToFrequency(82.5 / (lavDia * personas), 'jabon');
// }

// ════════════════════════════════════════════════════════════
// RAW DAYS + SHARED UTILS
// ════════════════════════════════════════════════════════════

function computeRawDays(item) {
  const lavSem = answers.P4 || 4;
  const frag = answers.P3 || '++';
  const frecH = answers.PH || answers.KH || '3x_sem';
  const p2 = answers.P2 || [];
  const casaGrande = p2.includes('casa_grande');
  const peques = p2.includes('peques');
  const mascota = p2.includes('mascota');
  switch (item.key) {
    case 'det40': return (20 / lavSem) * 7;
    case 'det360': case 'bebe360': return lavSem >= 8 ? 300 : lavSem >= 5 ? 360 : 540;
    case 'perlas': case 'rec_perlas': {
      const g = frag === '+++' ? 30 : frag === '++' ? 20 : 10;
      return (300 / g / lavSem) * 7;
    }
    case 'oxis': case 'rec_oxiclean': {
      return (500 / 15 / lavSem) * 7;
    }
    case 'rec_oxiwhite': return (500 / 15 / lavSem) * 7;
    case 'quitamanchas': return (peques || mascota) ? 240 : 360;
    case 'pastillas': return (60 / (answers.P5a || 5)) * 7;
    case 'lavmano': case 'lavmanopolvo': return 250 / (answers.P5b || 3);
    case 'friegasuelos': {
      const fregados = casaGrande ? 15 : 30;
      const fregSem = frecH === 'diario' ? 3 : frecH === '3x_sem' ? 2 : 1;
      return (fregados / fregSem) * 7;
    }
    case 'flisflis': case 'antical': case 'desengrasante':
    case 'limpiacristales': case 'multisuperficies':
    case 'rec_antical': case 'rec_desengrasante':
    case 'rec_limpiacristales': case 'rec_multisuperficies': {
      const map = { diario:{n:90,g:180}, '3x_sem':{n:180,g:360}, '1x_sem':{n:360,g:360} };
      const f = map[frecH] || map['3x_sem'];
      return casaGrande ? f.g : f.n;
    }
    case 'acido': case 'rec_acido': return 90;
    // KĒR disabled (re-enable when Kēr quiz is reactivated):
    // case 'champu': return (27.5 / ((answers.KP2a || 3) * (answers.KP1 || 1))) * 7;
    // case 'gel': return (20.625 / ((answers.KP2b || 7) * (answers.KP1 || 1))) * 7;
    // case 'jabon': {
    //   const lavDia = {'1-3':2, '4-6':5, '7-10':8.5, '+10':12}[answers.KP2c] || 5;
    //   return 82.5 / (lavDia * (answers.KP1 || 1));
    // }
    default: return null;
  }
}

function freqToDays(f) {
  if (f.endsWith('d')) return parseInt(f);
  if (f.endsWith('m')) return parseInt(f) * 30;
  return 30;
}

const STAR_PRIORITY = {
  det40: 100, bebe360: 100, /* KĒR disabled: champu: 90, gel: 80, jabon: 70, */
  pastillas: 50, friegasuelos: 40, perlas: 30, lavmano: 20, flisflis: 10,
  antical: 9, desengrasante: 9, limpiacristales: 9, multisuperficies: 9,
  oxis: 8, rec_antical: 7, rec_desengrasante: 7, rec_limpiacristales: 7,
  rec_multisuperficies: 7, rec_perlas: 7, rec_oxiwhite: 4, rec_oxiclean: 4,
  quitamanchas: 6, det360: 5, rec_acido: 3, lavmanopolvo: 7, acido: 2, tierras: 1
};

// ════════════════════════════════════════════════════════════
// CaaS v3: Simple grouping
// ════════════════════════════════════════════════════════════

function assignShipments(items) {
  const subItems = items.filter(i => i.rawDays && !PRODUCTS[i.key]?.otp);
  if (subItems.length === 0) return;
  subItems.forEach(item => { item.shipmentGroup = freqToDays(item.freq); });
  dbg('CaaS v3: ' + new Set(subItems.map(i=>i.shipmentGroup)).size + ' cajas');
}

// ════════════════════════════════════════════════════════════
// QUIZ ENGINE
// ════════════════════════════════════════════════════════════

function getEl(id) { return document.getElementById(id); }

function applyBranding() {
  // Find the quiz container and set CSS vars on it
  var containers = document.querySelectorAll('.ntl-quiz');
  containers.forEach(function(root) {
    // KĒR branding disabled — re-enable when Kēr quiz is reactivated
    // if (quizType === 'ker') {
    //   root.style.setProperty('--accent', 'var(--ker-accent)');
    //   root.style.setProperty('--accent-dark', 'var(--ker-accent-dark)');
    //   root.style.setProperty('--accent-soft', 'var(--ker-accent-soft)');
    //   root.style.setProperty('--accent-light', 'var(--ker-accent-light)');
    // } else {
      root.style.setProperty('--accent', 'var(--hom-accent)');
      root.style.setProperty('--accent-dark', 'var(--hom-accent-dark)');
      root.style.setProperty('--accent-soft', 'var(--hom-accent-soft)');
      root.style.setProperty('--accent-light', 'var(--hom-accent-light)');
    // }
  });
  var tag = getEl('quizTag');
  var title = getEl('quizTitle');
  // KĒR disabled: always show HOM tag and title
  if (tag) tag.textContent = 'HOM'; // was: quizType === 'ker' ? 'KĒR' : 'HOM'
  if (title) title.innerHTML = '<span class="quiz-tag" id="quizTag">HOM</span>' + LANG.title_hom; // was: (quizType === 'ker' ? 'KĒR' : 'HOM') + (quizType === 'ker' ? LANG.title_ker : LANG.title_hom)
}

function startQuiz(selectedMode) {
  mode = selectedMode || 'landing_hom';
  // KĒR disabled: quizType is always 'hom'
  // quizType = mode.startsWith('landing_ker') || mode.startsWith('pdp_champu') || mode.startsWith('pdp_gel') || mode.startsWith('pdp_jabon') ? 'ker' : 'hom';
  quizType = 'hom';
  answers = {};
  currentStep = 0;
  _quizCompleted = false;
  _quizStartTime = Date.now();
  flow = [...FLOWS[mode]];
  applyBranding();
  _initQuizIds();
  // Fetch live product data in background
  _fetchProductData();
  // Klaviyo + Sheet: quiz started
  _klavIdentify({ 'Quiz > Dónde lo hizo': 'web', 'Quiz > Tipo de quiz': quizType });
  _klavTrack('Quiz Iniciado', { quiz_type: quizType, source: 'web' });
  _logToSheet([{ action_type: 'quiz_started' }]);
  const overlay = getEl('quizOverlay');
  if (overlay) overlay.showModal();
  document.body.style.overflow = 'hidden';
  renderStep();
}

function closeQuiz() {
  // Track abandon if quiz not completed
  if (!_quizCompleted && _quizStartTime > 0) {
    var duration = Math.round((Date.now() - _quizStartTime) / 1000);
    var stepId = flow && flow[currentStep] ? flow[currentStep] : 'unknown';
    const abandonProfile = _klavBuildProfile();
    abandonProfile['Quiz > Abandonado sin terminar'] = true;
    abandonProfile['Quiz > Último paso antes de abandonar'] = stepId;
    _klavIdentify(abandonProfile);
    _klavTrack('Quiz Abandonado', {
      quiz_type: quizType, source: 'web',
      last_step: stepId, steps_completed: currentStep,
      duration: duration
    });
    // Use _logToSheet so all answered fields up to this point are included
    _logToSheet([{
      action_type: 'quiz_abandoned',
      last_step: stepId,
      steps_completed: currentStep,
      quiz_duration: duration
    }]);
  }
  const overlay = getEl('quizOverlay');
  if (overlay) overlay.close();
  document.body.style.overflow = '';
  saveState();
}

function resetQuiz() {
  answers = {};
  currentStep = 0;
  sessionStorage.removeItem('nq_state');
  closeQuiz();
}

function getActiveFlow() {
  var result = [];
  for (var i = 0; i < FLOWS[mode].length; i++) {
    var s = FLOWS[mode][i];
    result.push(s);
    if (s === 'P2') {
      var p2 = answers.P2 || [];
      if (p2.includes('mascota')) {
        result.push('P2_MASCOTA');
        if (['gato','ambos'].includes(answers.P2_MASCOTA)) result.push('P2_ARENA');
      }
    }
    if (s === 'P5') {
      if (answers.P5 === 'si') result.push('P5a');
      result.push('P5b');
    }
  }
  return result;
}

function renderStep() {
  flow = getActiveFlow();
  var stepId = flow[currentStep];
  if (!stepId) return;

  var pct = ((currentStep+1)/flow.length)*100;
  var bar = getEl('progressBar');
  if (bar) bar.style.width = pct+'%';

  var backBtn = getEl('backBtn');
  if (backBtn) {
    backBtn.style.display = currentStep > 0 ? '' : 'none';
    backBtn.onclick = goBack;
  }

  var nextBtn = getEl('nextBtn');
  var body = getEl('quizBody');
  var footer = getEl('quizFooter');

  if (stepId === 'RESULTS') {
    if (footer) footer.style.display = 'none';
    if (body) { body.innerHTML = ''; renderResults(body); }
    pushKlaviyo('completed');
    return;
  }

  if (footer) footer.style.display = '';
  var q = tQ(stepId);
  if (!q) { goNext(); return; }

  var html = '<div class="quiz-step active">';
  html += '<div class="quiz-question">' + q.q + '</div>';
  if (q.sub) html += '<div class="quiz-subtitle">' + q.sub + '</div>';

  if (q.type === 'radio') {
    html += '<div class="quiz-options">';
    q.opts.forEach(function(o) {
      var sel = answers[stepId]===o.v?' selected':'';
      html += '<div class="quiz-option' + sel + '" data-value="' + o.v + '" onclick="window._ntlQuiz.pickRadio(this,\'' + stepId + '\',\'' + o.v + '\')">';
      html += '<span class="quiz-option-indicator"></span>';
      if (o.e) html += '<span class="quiz-option-emoji">' + o.e + '</span>';
      html += '<span class="quiz-option-text"><span class="quiz-option-label">' + o.l + '</span>';
      if (o.d) html += '<div class="quiz-option-desc">' + o.d + '</div>';
      html += '</span></div>';
    });
    html += '</div>';
    if (nextBtn) nextBtn.disabled = !answers[stepId];
  } else if (q.type === 'checkbox') {
    var cur = answers[stepId]||[];
    html += '<div class="quiz-options">';
    q.opts.forEach(function(o) {
      var sel = cur.includes(o.v)?' selected':'';
      html += '<div class="quiz-option checkbox' + sel + '" data-value="' + o.v + '" onclick="window._ntlQuiz.pickCheck(this,\'' + stepId + '\',\'' + o.v + '\')">';
      html += '<span class="quiz-option-indicator"></span>';
      if (o.e) html += '<span class="quiz-option-emoji">' + o.e + '</span>';
      html += '<span class="quiz-option-text"><span class="quiz-option-label">' + o.l + '</span>';
      if (o.d) html += '<div class="quiz-option-desc">' + o.d + '</div>';
      html += '</span></div>';
    });
    html += '</div>';
    if (nextBtn) nextBtn.disabled = cur.length===0;
  } else if (q.type === 'stepper') {
    var val = answers[stepId]||q.def;
    answers[stepId] = val;
    html += '<div class="quiz-stepper">';
    html += '<button onclick="window._ntlQuiz.stepper(\'' + stepId + '\',-1,' + q.min + ',' + q.max + ')">−</button>';
    html += '<div><span class="stepper-value" id="sv_' + stepId + '">' + val + '</span><div class="stepper-unit">' + q.unit + '</div></div>';
    html += '<button onclick="window._ntlQuiz.stepper(\'' + stepId + '\',1,' + q.min + ',' + q.max + ')">+</button>';
    html += '</div>';
    if (nextBtn) nextBtn.disabled = false;
  } else if (q.type === 'email') {
    html += '<div class="quiz-email-wrap">';
    html += '<input type="email" class="quiz-email-input" placeholder="tu@email.com" value="' + (answers.EMAIL||'') + '" oninput="window._ntlQuiz.answers.EMAIL=this.value">';
    html += '<span class="quiz-email-skip" onclick="window._ntlQuiz.answers.EMAIL=\'\';window._ntlQuiz.goNext()">' + LANG.skip_email + '</span>';
    html += '</div>';
    if (nextBtn) { nextBtn.disabled = false; nextBtn.textContent = LANG.cta_email; }
  }

  html += '</div>';
  if (body) body.innerHTML = html;
  if (q.type !== 'email' && nextBtn) nextBtn.textContent = LANG.next;
  if (nextBtn) nextBtn.onclick = goNext;
  dbg('Step ' + currentStep + ': ' + stepId);
}

function pickRadio(el, sid, val) {
  answers[sid] = val;
  el.parentElement.querySelectorAll('.quiz-option').forEach(function(o){o.classList.remove('selected');});
  el.classList.add('selected');
  var btn = getEl('nextBtn');
  if (btn) btn.disabled = false;
  pushKlaviyo(sid);
}

function pickCheck(el, sid, val) {
  dbg('pickCheck: sid=' + sid + ' val=' + val + ' current=' + JSON.stringify(answers[sid]));
  if (!Array.isArray(answers[sid])) answers[sid]=[];
  if (val==='nada') {
    answers[sid]=['nada'];
    el.parentElement.querySelectorAll('.quiz-option').forEach(function(o){o.classList.remove('selected');});
    el.classList.add('selected');
  } else {
    answers[sid]=answers[sid].filter(function(v){return v!=='nada';});
    var nadaEl = el.parentElement.querySelector('[data-value="nada"]');
    if (nadaEl) nadaEl.classList.remove('selected');
    if (answers[sid].includes(val)) { answers[sid]=answers[sid].filter(function(v){return v!==val;}); el.classList.remove('selected'); }
    else { answers[sid].push(val); el.classList.add('selected'); }
  }
  dbg('pickCheck result: ' + JSON.stringify(answers[sid]));
  var btn = getEl('nextBtn');
  if (btn) btn.disabled=answers[sid].length===0;
  pushKlaviyo(sid);
}

function stepperFn(sid, d, mn, mx) {
  var v=(answers[sid]||Q[sid].def)+d;
  v=Math.max(mn,Math.min(mx,v));
  answers[sid]=v;
  var el = getEl('sv_'+sid);
  if (el) el.textContent=v;
}

function goNext() {
  const stepId = flow[currentStep];
  // Capture email from DOM input in case oninput didn't fire (e.g. autofill on mobile)
  if (stepId === 'EMAIL') {
    const emailInput = document.querySelector('.quiz-email-input');
    if (emailInput?.value) answers.EMAIL = emailInput.value;
  }
  if (Q[stepId] && Q[stepId].type === 'stepper') pushKlaviyo(stepId);
  currentStep++; renderStep(); saveState();
}
function goBack() { if(currentStep>0){currentStep--;renderStep();saveState();} }

// ════════════════════════════════════════════════════════════
// RESULTS
// ════════════════════════════════════════════════════════════

function getSubPrice(item) {
  if (item.subPrice != null) return item.subPrice;
  if (item.discount) return item.price * (1 - item.discount / 100);
  return item.price;
}

function buildRecurringBreakdownHTML(checkedItems) {
  if (!checkedItems || checkedItems.length === 0) return '';
  var subItems = [];
  checkedItems.forEach(function(i) {
    if (!i.freq || i.freq === 'otp') return;
    var freqL = i.freqLabel || 'Compra única';
    if (freqL === 'Compra única') return;
    var days = freqToDays(i.freq);
    if (days >= 9999) return;
    var freqMonths = Math.round(days / 30);
    if (freqMonths < 1) return;
    var rec = i.recurringPrice;
    var price = rec ? rec * i.qty : getSubPrice(i) * i.qty;
    var compareAt = (i.compareAt || i.price) * i.qty;
    subItems.push({ name: i.name, qty: i.qty, price: price, compareAt: compareAt, freqMonths: freqMonths });
  });
  if (subItems.length === 0) return '';
  var NUM_SHIPMENTS = 4;
  var shipments = [];
  for (var month = 1; month <= 36 && shipments.length < NUM_SHIPMENTS; month++) {
    var due = [];
    subItems.forEach(function(item) { if (month % item.freqMonths === 0) due.push(item); });
    if (due.length > 0) {
      var total = due.reduce(function(s, i) { return s + i.price; }, 0);
      var totalCompare = due.reduce(function(s, i) { return s + i.compareAt; }, 0);
      shipments.push({ month: month, items: due, total: total, totalCompare: totalCompare });
    }
  }
  if (shipments.length === 0) return '';
  var next = shipments[0];
  var html = '<div class="recurring-breakdown" id="recurBreakdown">';
  html += '<div class="rb-toggle" onclick="document.getElementById(\'recurBreakdown\').classList.toggle(\'open\')">';
  html += '<span class="rb-arrow">▸</span>';
  html += '<span class="rb-label">' + LANG.next_shipments + shipments.length + LANG.shipments_label + '</span>';
  html += '<span class="rb-price"><span class="st-compare">' + next.totalCompare.toFixed(2) + '€</span> ' + next.total.toFixed(2) + '€</span>';
  html += '</div><div class="rb-details">';
  shipments.forEach(function(shipment) {
    html += '<div class="rb-group"><div class="rb-group-header">';
    html += '<span class="rb-connector">📦</span>';
    html += '<span class="rb-group-freq">' + LANG.month_label + shipment.month + '</span>';
    html += '<span class="rb-group-total"><span class="st-compare" style="font-size:11px">' + shipment.totalCompare.toFixed(2) + '€</span> ' + shipment.total.toFixed(2) + '€</span>';
    html += '</div>';
    shipment.items.forEach(function(item) {
      html += '<div class="rb-group-item"><span class="rb-item-name">' + item.name + (item.qty > 1 ? ' ×' + item.qty : '') + '</span>';
      html += '<span class="rb-item-price">' + item.price.toFixed(2) + '€</span></div>';
    });
    html += '</div>';
  });
  html += '</div></div>';
  return html;
}

function renderProductCard(item) {
  var checkedCls = item.checked ? ' checked' : '';
  var suggestedCls = item.suggested ? ' suggested' : '';
  var prod = PRODUCTS[item.key];
  var imgSrc = item.img || '';
  if (prod && prod.variantImages) {
    var frag = selectedFragrances[item.key] || Object.keys(prod.variants || {})[0];
    if (frag && prod.variantImages[frag]) imgSrc = prod.variantImages[frag];
  }
  var subPrice = getSubPrice(item);
  var compareAt = item.compareAt;
  var recPrice = item.recurringPrice;
  var priceHTML;
  if (recPrice) {
    var initialTotal = (subPrice * item.qty).toFixed(2);
    var recurTotal = (recPrice * item.qty).toFixed(2);
    priceHTML = '<div class="pc-price-dual"><div class="pc-price-initial"><span class="pc-price-tag">' + LANG.first_shipment + '</span>';
    if (compareAt) priceHTML += '<span class="pc-compare">' + (compareAt * item.qty).toFixed(2) + '€</span>';
    priceHTML += '<span class="pc-sub-price">' + initialTotal + '€</span></div>';
    priceHTML += '<div class="pc-price-recurring"><span class="pc-price-tag recur">' + LANG.future_refills + '</span>';
    priceHTML += '<span class="pc-sub-price recur">' + recurTotal + '€</span></div></div>';
  } else {
    var strikePrice = compareAt || (item.discount ? item.price : null);
    var hasDiscount = strikePrice && strikePrice > subPrice;
    var savingsPercent = hasDiscount ? Math.round((1 - subPrice / strikePrice) * 100) : 0;
    priceHTML = hasDiscount
      ? '<span class="pc-compare">' + (strikePrice * item.qty).toFixed(2) + '€</span><span class="pc-sub-price">' + (subPrice * item.qty).toFixed(2) + '€</span><span class="pc-savings-label">' + LANG.save_pct + savingsPercent + '%</span>'
      : '<span class="pc-sub-price">' + (subPrice * item.qty).toFixed(2) + '€</span>';
  }
  var fragHTML = '';
  if (prod && prod.hasFragrance && prod.variants) {
    var fragOptions = Object.keys(prod.variants);
    var defaultFrag = selectedFragrances[item.key] || fragOptions[0];
    fragHTML = '<div class="pc-fragrance" onclick="event.stopPropagation()"><span class="pc-frag-label">' + LANG.select_fragrance + '</span><div class="pc-frag-pills">';
    fragOptions.forEach(function(f) {
      var active = f === defaultFrag ? ' active' : '';
      fragHTML += '<span class="pc-frag-opt' + active + '" data-key="' + item.key + '" data-frag="' + f + '" onclick="window._ntlQuiz.selectFragrance(\'' + item.key + '\',\'' + f + '\',this)">' + f + '</span>';
    });
    fragHTML += '</div></div>';
  }
  return '<div class="product-card' + checkedCls + suggestedCls + '" id="pc_' + item.key + '" onclick="window._ntlQuiz.toggleCard(\'' + item.key + '\')">' +
    '<div class="pc-top"><div class="pc-check"></div><span class="pc-name">' + item.name + '</span>' +
    '<div class="pc-stepper" onclick="event.stopPropagation()"><button onclick="window._ntlQuiz.chgQty(\'' + item.key + '\',-1)">−</button>' +
    '<span class="qty" id="qty_' + item.key + '">' + item.qty + '</span>' +
    '<button onclick="window._ntlQuiz.chgQty(\'' + item.key + '\',1)">+</button></div></div>' +
    '<div class="pc-body"><div class="pc-img" id="img_' + item.key + '">' +
    (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.name + '" onerror="this.parentElement.textContent=\'📦\'">' : '📦') +
    '</div><div class="pc-details"><div class="pc-freq">' + item.freqLabel + '</div>' + fragHTML +
    '<div class="pc-price">' + priceHTML + '</div>' +
    (item.badge ? '<div class="pc-badge">' + item.badge + '</div>' : '') +
    '</div></div></div>';
}

function renderResults(container) {
  var items = buildBundle();
  resultItems = items;
  var isPDP = mode.startsWith('pdp_');
  var pdpProduct = isPDP ? mode.replace('pdp_','') : null;
  if (!isPDP) assignShipments(items);
  var html = '';

  // Subscription benefits strip
  html += '<div class="subs-benefits"><div class="subs-benefit"><span class="sb-icon">🚫</span>' + LANG.ben_no_commit + '</div><div class="subs-benefit"><span class="sb-icon">📦</span>' + LANG.ben_free_ship + '</div><div class="subs-benefit"><span class="sb-icon">⏸️</span>' + LANG.ben_pause + '</div><div class="subs-benefit"><span class="sb-icon">💰</span>' + LANG.ben_discount + '</div></div>';

  // PDP Hero
  if (isPDP && pdpProduct) {
    var heroItem = items.find(function(i) { return i.key === pdpProduct || i.pdpMatch; });
    if (heroItem) {
      var heroSub = getSubPrice(heroItem) * heroItem.qty;
      var heroCompare = (heroItem.compareAt || heroItem.price) * heroItem.qty;
      var heroRecurring = heroItem.recurringPrice;
      var heroProd = PRODUCTS[heroItem.key];
      var heroFragHTML = '';
      var heroImgSrc = heroItem.img || '';
      if (heroProd && heroProd.hasFragrance && heroProd.variants) {
        var fragOpts = Object.keys(heroProd.variants);
        var defaultFrag = selectedFragrances[heroItem.key] || fragOpts[0];
        if (heroProd.variantImages && heroProd.variantImages[defaultFrag]) heroImgSrc = heroProd.variantImages[defaultFrag];
        heroFragHTML = '<div class="pc-fragrance" style="margin-top:8px"><span class="pc-frag-label">' + LANG.select_fragrance + '</span><div class="pc-frag-pills">';
        fragOpts.forEach(function(f) {
          var act = f === defaultFrag ? ' active' : '';
          heroFragHTML += '<span class="pc-frag-opt' + act + '" onclick="window._ntlQuiz.selectFragrance(\'' + heroItem.key + '\',\'' + f + '\',this)">' + f + '</span>';
        });
        heroFragHTML += '</div></div>';
      }
      html += '<div class="result-hero"><div class="rh-label">' + LANG.ideal_freq + '</div><div class="rh-freq">' + heroItem.freqLabel + '</div>';
      html += '<div class="rh-product-card"><div class="rh-product-img">' + (heroImgSrc ? '<img src="' + heroImgSrc + '" alt="' + heroItem.name + '">' : '📦') + '</div>';
      html += '<div class="rh-product-details"><div class="rh-product-name">' + heroItem.name + '</div>' + heroFragHTML;
      html += '<div class="rh-product-price">';
      if (heroRecurring) {
        html += '<div class="rh-price-dual"><div class="rh-price-row"><span class="rh-price-tag">' + LANG.first_shipment + '</span>';
        if (heroCompare > heroSub) html += '<span class="compare">' + heroCompare.toFixed(2) + '€</span>';
        html += '<span class="sub-price">' + heroSub.toFixed(2) + '€</span></div>';
        html += '<div class="rh-price-row"><span class="rh-price-tag recur">' + LANG.future_refills + '</span><span class="sub-price recur">' + (heroRecurring * heroItem.qty).toFixed(2) + '€</span></div></div>';
      } else {
        if (heroCompare > heroSub) html += '<span class="compare">' + heroCompare.toFixed(2) + '€</span>';
        html += '<span class="sub-price">' + heroSub.toFixed(2) + '€</span>';
        if (heroCompare > heroSub) html += '<span class="savings-label">' + LANG.save_pct + Math.round((1 - heroSub/heroCompare) * 100) + '%</span>';
      }
      html += '</div></div></div>';
      html += '<div class="rh-desc">' + LANG.hero_desc + '</div></div>';
    }
  }

  // Zero mental load badge
  if (!isPDP) {
    html += '<div class="zero-load"><div class="zl-emoji">🧠✨</div><div class="zl-title">' + LANG.zl_title + '</div><div class="zl-desc">' + LANG.zl_desc + '</div></div>';
  }

  // Results header
  // KĒR disabled: always use badge_hom
  html += '<div class="results-header"><div class="caas-badge">' + LANG.badge_hom + '</div>'; // was: quizType==='hom' ? LANG.badge_hom : LANG.badge_ker
  html += '<h3>' + (isPDP ? LANG.results_title_pdp : LANG.results_title) + '</h3>';
  html += '<p>' + items.filter(function(i){return i.checked;}).length + LANG.products_for_you + '</p></div>';

  // PDP cross-sells (grouped by cadence) or Landing shipment boxes
  if (isPDP) {
    var crossItems = items.filter(function(i) { return !i.pdpMatch; });
    if (crossItems.length > 0) {
      html += '<div class="crosssell-section"><div class="crosssell-header">' + LANG.crosssell_title + '</div><div class="crosssell-desc">' + LANG.crosssell_desc + '</div>';
      var crossCadence = {};
      crossItems.forEach(function(i) {
        var cadence = i.freq === 'otp' ? 'otp' : String(freqToDays(i.freq));
        if (!crossCadence[cadence]) crossCadence[cadence] = [];
        crossCadence[cadence].push(i);
      });
      var cadenceKeys = Object.keys(crossCadence).sort(function(a, b) {
        if (a === 'otp') return 1; if (b === 'otp') return -1;
        return parseInt(a) - parseInt(b);
      });
      cadenceKeys.forEach(function(ck) {
        var group = crossCadence[ck];
        var isOTP = ck === 'otp';
        var checkedGroup = group.filter(function(i) { return i.checked; });
        var groupPrice = checkedGroup.reduce(function(s, i) { return s + (getSubPrice(i) * i.qty); }, 0);
        if (isOTP) {
          if (checkedGroup.length === 0) return;
          html += '<div class="shipment-box shipment-otp" data-cadence="otp"><div class="shipment-header"><span class="sh-icon">🛍️</span><span class="sh-label">' + LANG.otp_label + '</span><span class="sh-total">' + groupPrice.toFixed(2) + '€</span></div>';
        } else {
          var cadenceDays = parseInt(ck);
          var freqStr = cadenceDays <= 120
            ? (FREQ_LABELS[cadenceDays + 'd'] || 'tous les ' + cadenceDays + LANG.days_fallback)
            : (FREQ_LABELS[Math.round(cadenceDays / 30) + 'm'] || 'tous les ' + Math.round(cadenceDays / 30) + LANG.months_fallback);
          html += '<div class="shipment-box" data-cadence="' + cadenceDays + '"><div class="shipment-header"><span class="sh-icon">📦</span><span class="sh-label">' + freqStr + '</span><span class="sh-count">' + checkedGroup.length + (checkedGroup.length !== 1 ? LANG.product_plural : LANG.product_singular) + '</span><span class="sh-total">' + (groupPrice > 0 ? groupPrice.toFixed(2) + LANG.per_shipment : '') + '</span></div>';
        }
        group.sort(function(a, b) { return a.checked !== b.checked ? (a.checked ? -1 : 1) : 0; });
        group.forEach(function(i) { html += renderProductCard(i); });
        html += '</div>';
      });
      html += '</div>';
    }
  } else {
    // Landing: CaaS shipment boxes
    var shipmentsMap = {};
    items.forEach(function(i) {
      var sg = i.shipmentGroup || (PRODUCTS[i.key]?.otp ? 'otp' : freqToDays(i.freq));
      if (!shipmentsMap[sg]) shipmentsMap[sg] = [];
      shipmentsMap[sg].push(i);
    });
    var shipmentKeys = Object.keys(shipmentsMap).sort(function(a, b) {
      if (a === 'otp') return 1;
      if (b === 'otp') return -1;
      return parseInt(a) - parseInt(b);
    });
    shipmentKeys.forEach(function(sk) {
      var group = shipmentsMap[sk];
      var isOTP = sk === 'otp';
      var checkedGroup = group.filter(function(i) { return i.checked; });
      var groupPrice = checkedGroup.reduce(function(s, i) { return s + (getSubPrice(i) * i.qty); }, 0);
      var isEmpty = checkedGroup.length === 0;
      if (isOTP) {
        if (isEmpty) return;
        html += '<div class="shipment-box shipment-otp" data-cadence="otp"><div class="shipment-header"><span class="sh-icon">🛍️</span><span class="sh-label">' + LANG.otp_label + '</span><span class="sh-total">' + groupPrice.toFixed(2) + '€</span></div>';
      } else {
        var cadence = parseInt(sk);
        var freqStr = cadence <= 120
          ? (FREQ_LABELS[cadence + 'd'] || 'tous les ' + cadence + LANG.days_fallback)
          : (FREQ_LABELS[Math.round(cadence / 30) + 'm'] || 'tous les ' + Math.round(cadence / 30) + LANG.months_fallback);
        html += '<div class="shipment-box' + (isEmpty ? ' shipment-empty' : '') + '" data-cadence="' + cadence + '"><div class="shipment-header"><span class="sh-icon">📦</span><span class="sh-label">' + freqStr + '</span><span class="sh-count">' + checkedGroup.length + (checkedGroup.length !== 1 ? LANG.product_plural : LANG.product_singular) + '</span><span class="sh-total">' + (isEmpty ? '' : groupPrice.toFixed(2) + LANG.per_shipment) + '</span></div>';
      }
      group.sort(function(a, b) { return a.checked !== b.checked ? (a.checked ? -1 : 1) : 0; });
      group.forEach(function(i) { html += renderProductCard(i); });
      html += '</div>';
    });
  }

  // Summary
  var checked = items.filter(function(i){return i.checked;});
  var totalBefore = checked.reduce(function(s,i){return s+((i.compareAt||i.price)*i.qty);}, 0);
  var totalSub = checked.reduce(function(s,i){return s+(getSubPrice(i)*i.qty);}, 0);
  var totalSavings = totalBefore - totalSub;
  var sortedChecked = checked.slice().sort(function(a,b) { return freqToDays(a.freq||'30d') - freqToDays(b.freq||'30d'); });

  html += '<div class="results-summary" id="summaryBox"><div class="summary-toggle" onclick="document.getElementById(\'summaryBox\').classList.toggle(\'open\')"><span class="st-label">' + LANG.your_plan + ' · ' + checked.length + (checked.length !== 1 ? LANG.product_plural : LANG.product_singular) + '</span><span class="st-arrow">▾</span></div>';
  html += '<div class="summary-details"><div class="summary-items">';
  sortedChecked.forEach(function(i) {
    var rec = i.recurringPrice;
    var iSub = (getSubPrice(i) * i.qty).toFixed(2);
    html += '<div class="summary-item"><span class="si-name">' + i.name + (i.qty>1?' ×'+i.qty:'') + '</span><span class="si-freq">' + i.freqLabel + '</span><span class="si-price">' + iSub + '€' + (rec ? '<br><span class="si-recur">' + LANG.future_refills_s + (rec * i.qty).toFixed(2) + '€</span>' : '') + '</span></div>';
  });
  html += '</div></div>';
  html += '<div class="summary-total-wrap"><div class="summary-total"><span>' + LANG.summary_title + '</span><span><span class="st-compare">' + totalBefore.toFixed(2) + '€</span> ' + totalSub.toFixed(2) + '€</span></div>';
  html += '<div class="summary-savings">' + LANG.savings + totalSavings.toFixed(2) + LANG.savings_suffix + '</div></div>';
  html += buildRecurringBreakdownHTML(sortedChecked);
  html += '</div>';

  // CTA
  html += '<div class="results-cta"><button class="cta-main" onclick="window._ntlQuiz.addToCart()">' + LANG.add_to_cart + '</button></div>';

  // Cross-quiz (KĒR cross-sell disabled — re-enable when Kēr quiz is reactivated)
  // if (quizType==='hom') {
  //   html += '<div class="cross-quiz"><p>' + LANG.cross_ker_text + '</p><p><a onclick="window._ntlQuiz.startQuiz(\'landing_ker\')">' + LANG.cross_ker_cta + '</a></p></div>';
  // } else {
  //   html += '<div class="cross-quiz"><p>' + LANG.cross_hom_text + '</p><p><a onclick="window._ntlQuiz.startQuiz(\'landing_hom\')">' + LANG.cross_hom_cta + '</a></p></div>';
  // }

  container.innerHTML = html;
  dbg('Results: ' + items.length + ' items, ' + checked.length + ' checked, ' + totalSub.toFixed(2) + '€');
}

// ════════════════════════════════════════════════════════════
// BUNDLE BUILDER
// ════════════════════════════════════════════════════════════

function buildBundle() {
  var items = [];
  var p2 = answers.P2||[];
  var peques = p2.includes('peques');
  var mascota = p2.includes('mascota');
  var actividad = p2.includes('actividad');
  var casaGrande = p2.includes('casa_grande');
  var lavSem = answers.P4||4;
  var frag = answers.P3||'++';
  var frecH = answers.PH||answers.KH||'3x_sem';
  var isPDP = mode.startsWith('pdp_');
  var pdpProd = mode.replace('pdp_','');

  if (quizType === 'hom') {
    var det40 = calcDet40(lavSem);
    var det360 = calcDet360(lavSem);
    var highConsumption = det40.freq === '30d';
    if (peques) {
      var bebe360f = calcDet360(lavSem);
      items.push({key:'bebe360', ...PRODUCTS.bebe360, name:'Natulim Bebé 360 lavados', freq:bebe360f.freq, freqLabel:bebe360f.label, qty:1, checked:true, pdpMatch: pdpProd==='detergente', badge:'Para bebés 👶'});
    } else {
      items.push({key:'det40', ...PRODUCTS.det40, freq:det40.freq, freqLabel:det40.label, qty:det40.qty, checked:true, pdpMatch: pdpProd==='detergente'});
      if (highConsumption) items.push({key:'det360', ...PRODUCTS.det360, freq:det360.freq, freqLabel:det360.label, qty:det360.qty, checked:false, suggested:true, badge:'Opción ahorro alto consumo'});
    }
    var oxis = calcOxisNormal(lavSem);
    if (peques||mascota||actividad) {
      items.push({key:'oxis', ...PRODUCTS.oxis, name:'Oxi Clean', freq:oxis.freq, freqLabel:oxis.label, qty:oxis.qty, checked:true, pdpMatch: pdpProd==='oxis'});
    } else {
      items.push({key:'oxis', ...PRODUCTS.oxis, freq:oxis.freq, freqLabel:oxis.label, qty:oxis.qty, checked:false, suggested:true, pdpMatch: pdpProd==='oxis'});
    }
    if (frag !== 'sin') {
      var perlas = calcPerlas(lavSem, frag);
      var intLabel = frag==='+++'?'Muy intensa':frag==='++'?'Intensa':'Suave';
      items.push({key:'perlas', ...PRODUCTS.perlas, name:'Perlas '+intLabel, freq:perlas.freq, freqLabel:perlas.label, qty:perlas.qty, checked:true, pdpMatch: pdpProd==='perlas'});
    }
    var quit = calcQuitamanchas(peques, mascota);
    items.push({key:'quitamanchas', ...PRODUCTS.quitamanchas, freq:quit.freq, freqLabel:quit.label, qty:1, checked:peques||mascota, suggested:!(peques||mascota), pdpMatch: false});
    var lavManoFreq = calcLavMano(answers.P5b||3);
    if (answers.P5==='si') {
      var past = calcPastillas(answers.P5a||5);
      items.push({key:'pastillas', ...PRODUCTS.pastillas, freq:past.freq, freqLabel:past.label, qty:past.qty, checked:true, pdpMatch: pdpProd==='pastillas'});
      items.push({key:'lavmano', ...PRODUCTS.lavmano, freq:lavManoFreq.freq, freqLabel:lavManoFreq.label, qty:lavManoFreq.qty, checked:false, suggested:true, pdpMatch: pdpProd==='lavmano'});
    } else {
      items.push({key:'lavmano', ...PRODUCTS.lavmano, freq:lavManoFreq.freq, freqLabel:lavManoFreq.label, qty:lavManoFreq.qty, checked:true, pdpMatch: pdpProd==='lavmano'});
    }
    var frieg = calcFriegasuelos(frecH, casaGrande);
    items.push({key:'friegasuelos', ...PRODUCTS.friegasuelos, freq:frieg.freq, freqLabel:frieg.label, qty:frieg.qty, checked:true, pdpMatch: pdpProd==='friegasuelos'});
    var flis = calcFlisFlis(frecH, casaGrande);
    var flisVP = PRODUCTS.flisflis.variantPrices?.[flis.variant];
    items.push({key:'flisflis', ...PRODUCTS.flisflis, price: flisVP ? flisVP.price : PRODUCTS.flisflis.price, compareAt: flisVP ? flisVP.compareAt : PRODUCTS.flisflis.compareAt, subPrice: flisVP?.subPrice, freq:flis.freq, freqLabel:flis.label, qty:1, checked:true, pdpMatch: pdpProd==='flisflis', badge:flis.variant, selectedVariant: flis.variant, recurringPrice: PRODUCTS.flisflis.recurringPrices?.[flis.variant]});
    var acid = calcAcido();
    items.push({key:'acido', ...PRODUCTS.acido, freq:acid.freq, freqLabel:acid.label, qty:1, checked:false, suggested:true, pdpMatch: pdpProd==='acido'});

    // Individual Flis-Flis
    var flisIndividuals = ['antical','desengrasante','limpiacristales','multisuperficies'];
    var indHogar = calcIndividualHogar(frecH, casaGrande);
    flisIndividuals.forEach(function(pk) {
      var isPdpHero = pdpProd === pk;
      if (isPdpHero || pdpProd === 'rec_' + pk) {
        var prod = PRODUCTS[pk];
        var vp = prod.variantPrices?.[indHogar.variant];
        items.push({key: pk, ...prod, price: vp ? vp.price : prod.price, compareAt: vp ? vp.compareAt : prod.compareAt, subPrice: vp?.subPrice, freq: indHogar.freq, freqLabel: indHogar.label, qty: 1, checked: true, pdpMatch: isPdpHero, badge: indHogar.variant + ' uds', selectedVariant: indHogar.variant, recurringPrice: prod.recurringPrices?.[indHogar.variant] || prod.recurringPrice});
      }
    });

    // Recargas
    var recargaCalcMap = {
      rec_antical: function() { return indHogar; }, rec_desengrasante: function() { return indHogar; },
      rec_limpiacristales: function() { return indHogar; }, rec_multisuperficies: function() { return indHogar; },
      rec_perlas: function() { return frag !== 'sin' ? calcPerlas(lavSem, frag) : {freq:'90d', label:FREQ_LABELS['90d'], qty:1}; },
      rec_oxiwhite: function() { return calcOxisNormal(lavSem); }, rec_oxiclean: function() { return calcOxisNormal(lavSem); },
      rec_acido: function() { return calcAcido(); }, lavmanopolvo: function() { return calcLavMano(answers.P5b||3); },
    };
    Object.keys(recargaCalcMap).forEach(function(rk) {
      if (pdpProd === rk) {
        var rc = recargaCalcMap[rk]();
        var prod = PRODUCTS[rk];
        if (!prod) return;
        var hasVP = prod.variantPrices && Object.keys(prod.variantPrices).length > 1;
        var price = prod.price;
        var variant = null;
        if (hasVP) { variant = indHogar.variant || '2'; var vp = prod.variantPrices[variant]; if (vp) price = vp.price; }
        items.push({key: rk, ...prod, price: price, freq: rc.freq, freqLabel: rc.label, qty: rc.qty || 1, checked: true, pdpMatch: true, badge: variant ? variant + ' uds' : null, selectedVariant: variant});
      }
    });
    if (mascota||peques) {
      items.push({key:'tierras', ...PRODUCTS.tierras, freq:'otp', freqLabel:LANG.otp_label, qty:1, checked:mascota, suggested:!mascota, badge:LANG.no_subscription});
    }
  } // end if (quizType === 'hom')
  // ── KĒR bundle builder (disabled — re-enable when Kēr quiz is reactivated) ──
  // else {
  //   // KĒR
  //   var per = answers.KP1||1;
  //   var estado = answers.KP_EST||[];
  //   var piel = answers.KP_PIEL||'normal';
  //   var ch = calcChampu(per, answers.KP2a||3);
  //   var chVar = 'Sunrise (Daily)';
  //   if (estado.includes('seco')||estado.includes('tenido')) chVar='Fenix (Repair)';
  //   else if (estado.includes('graso')) chVar='Detox';
  //   items.push({key:'champu', ...PRODUCTS.champu, name:'Champú '+chVar, freq:ch.freq, freqLabel:ch.label, qty:ch.qty, checked:true, pdpMatch: pdpProd==='champu', badge:estado.includes('rizado')?'Apto método rizado':''});
  //   var ge = calcGel(per, answers.KP2b||7);
  //   var geVar = 'Radiance';
  //   if (piel==='sensible'||piel==='atopica') geVar='Clean&Calm';
  //   items.push({key:'gel', ...PRODUCTS.gel, name:'Gel '+geVar, freq:ge.freq, freqLabel:ge.label, qty:ge.qty, checked:true, pdpMatch: pdpProd==='gel', badge:piel==='atopica'?'Sin fragancia':''});
  //   var jb = calcJabon(per, answers.KP2c||'4-6');
  //   items.push({key:'jabon', ...PRODUCTS.jabon, freq:jb.freq, freqLabel:jb.label, qty:jb.qty, checked:true, pdpMatch: pdpProd==='jabon'});
  // }

  items.forEach(function(item) { item.rawDays = computeRawDays(item); });

  // Bundle rules
  var getPriority = function(item) { var p = STAR_PRIORITY[item.key] || 0; if (item.pdpMatch) p += 1000; return p; };
  var MAX_TOTAL = 8;
  var HARD_MIN = 2;
  var SOFT_MIN = 5;
  var MAX_SELECTED = 8;
  var has360 = items.some(function(i) { return i.key === 'det360' || i.key === 'bebe360'; });
  var BUDGET = has360 ? 130 : 80;
  var getItemTotal = function(i) { return getSubPrice(i) * i.qty; };

  items.sort(function(a, b) { return getPriority(b) - getPriority(a); });
  if (items.length > MAX_TOTAL) { items.length = MAX_TOTAL; }

  if (items.filter(function(i){return i.checked;}).length < SOFT_MIN) {
    var unchecked = items.filter(function(i){return !i.checked;}).sort(function(a,b){return getPriority(b)-getPriority(a);});
    for (var u = 0; u < unchecked.length; u++) {
      if (items.filter(function(i){return i.checked;}).length >= SOFT_MIN) break;
      unchecked[u].checked = true;
      unchecked[u].suggested = false;
    }
  }

  var checkedItems = items.filter(function(i){return i.checked;});
  var runningTotal = checkedItems.reduce(function(s,i){return s+getItemTotal(i);}, 0);
  if (runningTotal > BUDGET) {
    var byPriorityAsc = checkedItems.slice().sort(function(a,b){return getPriority(a)-getPriority(b);});
    for (var b = 0; b < byPriorityAsc.length; b++) {
      if (runningTotal <= BUDGET) break;
      if (items.filter(function(i){return i.checked;}).length <= HARD_MIN) break;
      if (byPriorityAsc[b].pdpMatch || byPriorityAsc[b].protected) continue;
      byPriorityAsc[b].checked = false;
      byPriorityAsc[b].suggested = true;
      runningTotal -= getItemTotal(byPriorityAsc[b]);
    }
  }
  if (runningTotal < BUDGET) {
    var suggested = items.filter(function(i){return !i.checked;}).sort(function(a,b){return getPriority(b)-getPriority(a);});
    for (var s = 0; s < suggested.length; s++) {
      if (items.filter(function(i){return i.checked;}).length >= MAX_SELECTED) break;
      var cost = getItemTotal(suggested[s]);
      if (runningTotal + cost <= BUDGET) { suggested[s].checked = true; suggested[s].suggested = false; runningTotal += cost; }
    }
  }
  if (mode.startsWith('pdp_')) { var match = items.find(function(i){return i.pdpMatch;}); if (match) match.checked = true; }

  dbg('Bundle: ' + items.length + ' items, ' + items.filter(function(i){return i.checked;}).length + ' checked');
  return items;
}

// ════════════════════════════════════════════════════════════
// INTERACTIONS
// ════════════════════════════════════════════════════════════

function selectFragrance(key, frag, el) {
  selectedFragrances[key] = frag;
  el.parentElement.querySelectorAll('.pc-frag-opt').forEach(function(o){o.classList.remove('active');});
  el.classList.add('active');
  var prod = PRODUCTS[key];
  if (prod && prod.variantImages && prod.variantImages[frag]) {
    var newSrc = prod.variantImages[frag];
    var cardImg = getEl('img_' + key);
    if (cardImg) cardImg.innerHTML = '<img src="' + newSrc + '" alt="' + prod.name + '" onerror="this.parentElement.textContent=\'📦\'">';
    var heroImg = document.querySelector('.ntl-quiz .rh-product-img');
    if (heroImg) heroImg.innerHTML = '<img src="' + newSrc + '" alt="' + prod.name + '">';
  }
}

function toggleCard(key) {
  var el = getEl('pc_'+key);
  if (el) el.classList.toggle('checked');
  updateSummary();
}

function chgQty(key, d) {
  var el = getEl('qty_'+key);
  if (!el) return;
  var v = parseInt(el.textContent)+d;
  if(v<1)v=1; if(v>10)v=10;
  el.textContent = v;
  updateSummary();
}

function updateSummary() {
  var checked = [];
  resultItems.forEach(function(item) {
    var card = getEl('pc_' + item.key);
    if (card) {
      if (!card.classList.contains('checked')) return;
      var qtyEl = card.querySelector('.qty');
      var qty = qtyEl ? parseInt(qtyEl.textContent) : item.qty;
      checked.push(Object.assign({}, item, {qty: qty}));
    } else if (item.pdpMatch) {
      checked.push(Object.assign({}, item));
    }
  });
  var totalBefore = checked.reduce(function(s, i) { return s + ((i.compareAt || i.price) * i.qty); }, 0);
  var totalSub = checked.reduce(function(s, i) { return s + (getSubPrice(i) * i.qty); }, 0);
  var totalSavings = totalBefore - totalSub;
  var sorted = checked.slice().sort(function(a, b) { return freqToDays(a.freq||'30d') - freqToDays(b.freq||'30d'); });
  var toggleLabel = document.querySelector('.ntl-quiz .st-label');
  if (toggleLabel) toggleLabel.textContent = LANG.your_plan + ' · ' + checked.length + (checked.length !== 1 ? LANG.product_plural : LANG.product_singular);
  var itemsContainer = document.querySelector('.ntl-quiz .summary-items');
  if (itemsContainer) {
    var html = '';
    sorted.forEach(function(i) {
      var rec = i.recurringPrice;
      var iSub = (getSubPrice(i) * i.qty).toFixed(2);
      html += '<div class="summary-item"><span class="si-name">' + i.name + (i.qty > 1 ? ' ×' + i.qty : '') + '</span><span class="si-freq">' + i.freqLabel + '</span><span class="si-price">' + iSub + '€' + (rec ? '<br><span class="si-recur">' + LANG.future_refills_s + (rec * i.qty).toFixed(2) + '€</span>' : '') + '</span></div>';
    });
    itemsContainer.innerHTML = html;
  }
  var totalDiv = document.querySelector('.ntl-quiz .summary-total');
  if (totalDiv) totalDiv.innerHTML = '<span>' + LANG.summary_title + '</span><span><span class="st-compare">' + totalBefore.toFixed(2) + '€</span> ' + totalSub.toFixed(2) + '€</span>';
  var savingsDiv = document.querySelector('.ntl-quiz .summary-savings');
  if (savingsDiv) savingsDiv.textContent = LANG.savings + totalSavings.toFixed(2) + LANG.savings_suffix;
  // Update recurring breakdown
  var rbDiv = getEl('recurBreakdown');
  var newRbHTML = buildRecurringBreakdownHTML(sorted);
  if (newRbHTML) {
    if (rbDiv) { var wasOpen = rbDiv.classList.contains('open'); rbDiv.outerHTML = newRbHTML; if (wasOpen) { var nr = getEl('recurBreakdown'); if (nr) nr.classList.add('open'); } }
    else { var totalWrap = document.querySelector('.ntl-quiz .summary-total-wrap'); if (totalWrap) totalWrap.insertAdjacentHTML('afterend', newRbHTML); }
  } else if (rbDiv) { rbDiv.remove(); }
  // Update shipment box headers
  document.querySelectorAll('.ntl-quiz .shipment-box[data-cadence]').forEach(function(box) {
    var checkedCards = box.querySelectorAll('.product-card.checked');
    var boxTotal = 0;
    checkedCards.forEach(function(card) {
      var key = card.id.replace('pc_', '');
      var item = resultItems.find(function(i) { return i.key === key; });
      if (!item) return;
      var qty = parseInt(card.querySelector('.qty')?.textContent || item.qty);
      boxTotal += getSubPrice(item) * qty;
    });
    var countEl = box.querySelector('.sh-count');
    var totalEl = box.querySelector('.sh-total');
    if (countEl) countEl.textContent = checkedCards.length + (checkedCards.length !== 1 ? LANG.product_plural : LANG.product_singular);
    if (totalEl) totalEl.textContent = box.dataset.cadence === 'otp' ? boxTotal.toFixed(2) + '€' : boxTotal.toFixed(2) + LANG.per_shipment;
  });
}

// ════════════════════════════════════════════════════════════
// CART + KLAVIYO
// ════════════════════════════════════════════════════════════

function getVariantId(key) {
  var prod = PRODUCTS[key];
  if (!prod || !prod.variants) return null;
  var variants = prod.variants;
  var keys = Object.keys(variants);
  if (keys.length === 1) return variants[keys[0]];
  if (prod.hasFragrance) { var frag = selectedFragrances[key] || keys[0]; return variants[frag]; }
  // KĒR variant logic (disabled — re-enable when Kēr quiz is reactivated):
  // if (key === 'champu') {
  //   var tipo = answers.KP_EST || [];
  //   var subVar = 'Sunrise';
  //   if (tipo.includes('seco')||tipo.includes('tenido')) subVar = 'Fenix';
  //   else if (tipo.includes('graso')) subVar = 'Detox';
  //   return variants['Recarga / ' + subVar];
  // }
  // if (key === 'gel') {
  //   var piel = answers.KP_PIEL || 'normal';
  //   var subVar2 = (piel==='sensible'||piel==='atopica') ? 'Clean&Calm' : 'Radiance';
  //   return variants['Recarga / ' + subVar2];
  // }
  // if (key === 'jabon') return variants['Recarga / Cloud'];
  if (key === 'flisflis') {
    var heroCard = resultItems.find(function(i) { return i.key === 'flisflis'; });
    var sv = heroCard?.selectedVariant || '2 de cada';
    return variants[sv] || variants['2 de cada'];
  }
  var multiVariantKeys = ['antical','desengrasante','limpiacristales','multisuperficies','rec_antical','rec_desengrasante','rec_limpiacristales','rec_multisuperficies'];
  if (multiVariantKeys.includes(key)) {
    var heroCard2 = resultItems.find(function(i) { return i.key === key; });
    var sv2 = heroCard2?.selectedVariant || '2';
    return variants[sv2] || variants[keys[0]];
  }
  return variants[keys[0]];
}

function getSellingPlanForItem(item) {
  var entry = SELLING_PLANS[item.key];
  if (!entry || item.freq === 'otp' || item.freqLabel === 'Compra única') return null;
  // Multi-variant: look up plans for specific variant
  var sp;
  if (entry._multiVariant) {
    var vid = item.selectedVariant ? (PRODUCTS[item.key]?.variants?.[item.selectedVariant] || '') : '';
    if (!vid) { var vKeys = Object.keys(PRODUCTS[item.key]?.variants || {}); vid = vKeys.length > 0 ? PRODUCTS[item.key].variants[vKeys[0]] : ''; }
    sp = entry[String(vid)];
    if (!sp) { dbg('No selling plans for variant ' + vid + ' of ' + item.key); return null; }
  } else {
    sp = entry;
  }
  var freqKeys = Object.keys(sp).filter(k => k !== '_multiVariant');
  // Direct match by freq key
  if (item.freq && sp[item.freq]) return { id: sp[item.freq], freq: item.freq };
  // Match by label (handles 90d↔3m automatically via shared FREQ_LABELS)
  for (var i = 0; i < freqKeys.length; i++) {
    if (FREQ_LABELS[freqKeys[i]] === item.freqLabel) return { id: sp[freqKeys[i]], freq: freqKeys[i] };
  }
  // Fallback: find closest available frequency by days
  var targetFreq = null;
  var allFreqs = Object.keys(FREQ_LABELS);
  for (var j = 0; j < allFreqs.length; j++) {
    if (FREQ_LABELS[allFreqs[j]] === item.freqLabel) { targetFreq = allFreqs[j]; break; }
  }
  if (!targetFreq) return { id: sp[freqKeys[freqKeys.length - 1]], freq: freqKeys[freqKeys.length - 1] };
  var targetDays = freqToDays(targetFreq);
  var bestKey = freqKeys[0];
  var bestDiff = Math.abs(freqToDays(freqKeys[0]) - targetDays);
  for (var k = 1; k < freqKeys.length; k++) {
    var diff = Math.abs(freqToDays(freqKeys[k]) - targetDays);
    if (diff < bestDiff) { bestDiff = diff; bestKey = freqKeys[k]; }
  }
  dbg('Selling plan fallback: ' + item.key + ' ' + item.freqLabel + ' → ' + bestKey);
  return { id: sp[bestKey], freq: bestKey };
}

function addToCart() {
  var cartItems = [];
  if (mode.startsWith('pdp_')) {
    var heroItem = resultItems.find(function(i) { return i.pdpMatch; });
    if (heroItem) {
      var vid = getVariantId(heroItem.key);
      var sp = getSellingPlanForItem(heroItem);
      if (vid) {
        var ci = { id: parseInt(vid), quantity: heroItem.qty, properties: { _quiz_source: quizType } };
        if (sp) { ci.selling_plan = parseInt(sp.id); ci.properties._quiz_freq = sp.freq; }
        cartItems.push(ci);
      }
    }
  }
  document.querySelectorAll('.ntl-quiz .product-card.checked').forEach(function(card) {
    var key = card.id.replace('pc_','');
    var qtyEl = card.querySelector('.qty');
    var qty = qtyEl ? parseInt(qtyEl.textContent) : 1;
    var variantId = getVariantId(key);
    if (!variantId) return;
    if (cartItems.some(function(ci) { return ci.id === parseInt(variantId); })) return;
    var item = resultItems.find(function(i) { return i.key === key; });
    var sp = item ? getSellingPlanForItem(item) : null;
    var ci = { id: parseInt(variantId), quantity: qty, properties: { _quiz_source: quizType } };
    if (sp) { ci.selling_plan = parseInt(sp.id); ci.properties._quiz_freq = sp.freq; }
    cartItems.push(ci);
  });
  if (cartItems.length === 0) { dbg('Cart: nothing selected'); return; }
  dbg('Cart add: ' + cartItems.length + ' items → POST /cart/add.js');
  dbg('Cart payload: ' + JSON.stringify(cartItems).substring(0, 300));
  var ctaBtn = document.querySelector('.ntl-quiz .results-cta');
  if (ctaBtn) { ctaBtn.disabled = true; ctaBtn.textContent = LANG.adding; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: cartItems })
  })
  .then(function(res) {
    if (!res.ok) return res.json().then(function(e) { throw new Error(e.description || ('HTTP ' + res.status)); });
    return res.json();
  })
  .then(function(data) {
    dbg('Cart OK: ' + data.items.length + ' items added');
    // Tag the cart as a quiz order (for Shopify Flow to filter)
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { '_quiz_order': 'true', '_quiz_session': _quizSessionId } })
    }).catch(function() {});
    // Klaviyo: track conversion
    var addedKeys = data.items.map(function(i) { return i.key || i.product_title; });
    var totalChecked = resultItems ? resultItems.filter(i => i.checked).length : 0;
    var level = data.items.length >= totalChecked ? 'full' : data.items.length > 0 ? 'partial' : 'none';
    _klavIdentify({
      'Quiz > Compró después del quiz': true,
      'Quiz > Conversión web': level
    });
    _klavTrack('Quiz Convertido', {
      quiz_type: quizType, source: 'web',
      items_added: data.items.length,
      total_recommended: totalChecked,
      conversion_level: level
    });
    // Log to Sheet
    var cartRows = data.items.map(function(ci) {
      return {
        action_type: 'cart_added',
        product_name: ci.product_title || ci.title || '',
        applied: true,
        price: ci.price ? ci.price / 100 : 0,
        total_applied: data.items.length,
        optimization_level: level
      };
    });
    _logToSheet(cartRows);
    _quizCompleted = true; // Prevent abandon tracking
    var results = {};
    resultItems.forEach(function(it) {
      var sp2 = getSellingPlanForItem(it);
      if (sp2) results[it.key] = { freq: sp2.freq, sellingPlan: sp2.id, qty: it.qty };
    });
    try { sessionStorage.setItem('natulim_quiz_results', JSON.stringify(results)); } catch(e) {}
    closeQuiz();
    // Refresh cart drawer sections and open it
    var sectionsUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + '?sections=cart-drawer,cart-icon-bubble';
    fetch(sectionsUrl)
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        Object.keys(sections).forEach(function(sectionId) {
          var el = document.getElementById('shopify-section-' + sectionId);
          if (el) el.innerHTML = new DOMParser().parseFromString(sections[sectionId], 'text/html').body.innerHTML;
        });
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function() {
        // Fallback: just open existing drawer
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      });
  })
  .catch(function(err) {
    dbg('Cart error: ' + err.message);
    _logToSheet([{ action_type: 'cart_error', quiz_status: 'error', error_detail: err.message || 'Unknown cart error' }]);
    if (ctaBtn) { ctaBtn.disabled = false; ctaBtn.textContent = LANG.add_to_cart_err; }
    alert(LANG.cart_error + err.message);
  });
}

function pushKlaviyo(step) {
  // Progressive identify — send quiz answers to Klaviyo on each step
  var profile = _klavBuildProfile();
  profile['Quiz > Último paso antes de abandonar'] = step;
  _klavIdentify(profile);

  if (step === 'completed') {
    _quizCompleted = true;
    var duration = _quizStartTime ? Math.round((Date.now() - _quizStartTime) / 1000) : 0;
    // Full profile + completion properties
    profile['Quiz > Completado'] = true;
    profile['Quiz > Abandonado sin terminar'] = false;
    profile['Quiz > Fecha de completar'] = new Date().toISOString().split('T')[0];
    if (typeof resultItems !== 'undefined' && resultItems) {
      var checked = resultItems.filter(i => i.checked);
      profile['Quiz > Productos recomendados'] = checked.map(i => i.key).join(',');
      var totalSub = checked.reduce((s, i) => s + ((i.subPrice || i.price * (1 - (i.discount || 0) / 100)) * (i.qty || 1)), 0);
      profile['Quiz > Valor mensual del plan (€)'] = Math.round(totalSub * 100) / 100;
      profile['Quiz > Detalle del plan (JSON)'] = JSON.stringify(checked.map(i => ({
        name: i.name, freq: i.freqLabel || i.freq, price: Math.round((i.subPrice || i.price) * 100) / 100
      })));
    }
    _klavIdentify(profile);
    _klavTrack('Quiz Completado', {
      quiz_type: quizType, source: 'web',
      products_recommended: checked ? checked.map(i => i.key) : [],
      estimated_ticket: totalSub || 0,
      duration: duration
    });
    // Log to Sheet — one row per recommended product
    if (typeof resultItems !== 'undefined' && resultItems) {
      var completedRows = resultItems.filter(i => i.freq && i.freq !== 'otp').map(i => ({
        action_type: 'quiz_completed',
        product_key: i.key,
        product_name: i.name || '',
        recommended_freq: i.freq,
        stock_status: 'new',
        applied: false,
        price: i.subPrice || i.price || 0,
        total_recommended: checked ? checked.length : 0,
        estimated_monthly_value: totalSub || 0,
        last_step: 'RESULTS',
        steps_completed: flow ? flow.length : 0,
        quiz_duration: duration
      }));
      _logToSheet(completedRows);
    }
  }
}

function saveState() {
  try {
    sessionStorage.setItem('nq_state', JSON.stringify({quizType:quizType, mode:mode, currentStep:currentStep, answers:answers, ts:Date.now()}));
  } catch(e) { /* silently fail */ }
}

function restoreState() {
  try {
    var s = JSON.parse(sessionStorage.getItem('nq_state'));
    if (!s || Date.now()-s.ts > 30*60*1000) return false;
    quizType = s.quizType;
    mode = s.mode;
    currentStep = s.currentStep;
    answers = s.answers;
    return true;
  } catch(e) { return false; }
}

function dbg(msg) {
  if (typeof console !== 'undefined') console.log('[NTL Quiz]', msg);
}

// ════════════════════════════════════════════════════════════
// PUBLIC API (exposed via window for onclick handlers)
// ════════════════════════════════════════════════════════════

window._ntlQuiz = {
  startQuiz: startQuiz,
  closeQuiz: closeQuiz,
  resetQuiz: resetQuiz,
  pickRadio: pickRadio,
  pickCheck: pickCheck,
  stepper: stepperFn,
  goNext: goNext,
  goBack: goBack,
  toggleCard: toggleCard,
  chgQty: chgQty,
  selectFragrance: selectFragrance,
  addToCart: addToCart,
  answers: answers
};

// ── SELLING PLANS (from Shopify API, verified 2026-03-06) ──
// Maps product key → quiz frequency → selling_plan numeric ID
var SELLING_PLANS = {
  det40:    { '30d':'690139627859', '60d':'690139660627', '90d':'690139693395' },
  det360:   { '10m':'690375950675', '12m':'690140348755', '18m':'690375983443' },
  bebe360:  { '365d':'690141790547' },
  oxis:     { '30d':'690141004115', '60d':'690141036883', '90d':'690141069651', '120d':'690376081747' },
  oxiwhite: { '30d':'690140381523', '60d':'690140447059', '90d':'690140414291', '120d':'690376016211' },
  perlas:   { '30d':'690141397331', '60d':'690141462867', '90d':'690141430099' },
  quitamanchas: { '4m':'690140086611', '8m':'690140119379', '12m':'690140152147' },
  pastillas: { '60d':'690139758931', '90d':'690139824467', '120d':'690139857235' },
  lavmano:  { '30d':'690147328339', '60d':'690147361107', '90d':'690147393875', '120d':'690376245587' },
  friegasuelos: { '30d':'690140217683', '60d':'690140184915', '90d':'690140283219', '120d':'690140250451' },
  flisflis: { '3m':'690145689939', '6m':'690145657171', '12m':'690145722707' },
  antical:  { '6m':'690146246995', '12m':'690146181459' },
  desengrasante: { '3m':'690145558867', '6m':'690145624403', '12m':'690145591635' },
  limpiacristales: { '6m':'690146410835', '12m':'690146443603' },
  multisuperficies: { '6m':'690146509139', '12m':'690146574675' },
  rec_antical: { '3m':'690146935123', '6m':'690147000659', '12m':'690146967891' },
  // KĒR selling plan IDs (disabled — re-enable when Kēr quiz is reactivated):
  // champu:   { '3m':'690373165395', '4m':'690373132627', '6m':'690373099859', '9m':'690383421779' },
  // gel:      { '3m':'690373198163', '4m':'690373230931', '6m':'690373263699', '9m':'690383454547' },
  // jabon:    { '3m':'690373362003', '6m':'690373296467', '9m':'690373329235', '12m':'690383389011' }
};

// ── HANDLE → MODE AUTO-DETECTION (for PDP block trigger) ──
var ID_TO_MODE = {
  // Colada
  '6105943638181': 'pdp_detergente',
  '7822551875798': 'pdp_detergente',
  '10386355814739': 'pdp_detergente',
  '10386329141587': 'pdp_detergente',
  '8598782083411': 'pdp_oxis',
  '8598676799827': 'pdp_oxis',
  '8874651484499': 'pdp_perlas',
  '8463115551059': 'pdp_pastillas',
  '9523575718227': 'pdp_lavmano',
  '9502213177683': 'pdp_lavmano',
  '7642485620950': 'pdp_friegasuelos',
  '9579400364371': 'pdp_flisflis',
  '9580013224275': 'pdp_flisflis',
  '9580409946451': 'pdp_flisflis',
  '9582894711123': 'pdp_flisflis',
  '9582902673747': 'pdp_flisflis',
  // Cuidado personal (Kēr) — disabled (re-enable when Kēr quiz is reactivated):
  // '10128511435091': 'pdp_champu',
  // '10128514023763': 'pdp_gel',
  // '10128516972883': 'pdp_jabon'
};

// ── INIT ──

// Escape key: use our closeQuiz() instead of browser default close
(function() {
  const overlay = getEl('quizOverlay');
  if (overlay && overlay.tagName === 'DIALOG') {
    overlay.addEventListener('cancel', function(e) {
      e.preventDefault();
      closeQuiz();
    });
  }
})();

// Listen for [data-quiz-open] triggers (landing sections)
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('[data-quiz-open]');
  if (trigger) {
    e.preventDefault();
    var selectedMode = trigger.getAttribute('data-quiz-open') || 'landing_hom';
    startQuiz(selectedMode);
  }
});

// Listen for [data-quiz-product] triggers (PDP block — auto-detects mode from handle)
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('[data-quiz-product]');
  if (trigger) {
    e.preventDefault();
    var handle = trigger.getAttribute('data-quiz-product');
    var detectedMode = ID_TO_MODE[handle];
    if (detectedMode) {
      startQuiz(detectedMode);
    } else {
      dbg('No quiz mode found for handle: ' + handle);
    }
  }
});

// Hide PDP trigger if product handle not in quiz database
document.querySelectorAll('[data-quiz-product]').forEach(function(el) {
  var handle = el.getAttribute('data-quiz-product');
  if (!ID_TO_MODE[handle]) {
    el.style.display = 'none';
    dbg('Quiz trigger hidden — product not in quiz: ' + handle);
  }
});

// Restore session if exists
if (restoreState()) {
  dbg('Session restored');
}

})();
